// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:03:24.668Z
// Property: Avignon Apartment Homes (ID: 6767906449167588)
// Collections: 32 amenities, 7 floorplans (live), 27 photos, 76 POIs, 5 reviews, 7 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167588",
  "property_external_id": "1124015",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/avignon-apartment-homes-olathe-ks/kj3p3mb/",
  "property_google_business_url": "https://www.google.com/maps/place/Avignon+Apartment+Homes/@38.9141565,-94.7512887,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0951461ed23e7:0x2813d16726137cdf!8m2!3d38.9141565!4d-94.7512887!16s%2Fg%2F1tdv_dhp?entry=ttu&g_ep=EgoyMDI2MDgxMi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124015 p1098967",
  "property_status": null,
  "property_slug": "avignon-apartments-homes",
  "property_name": "Avignon Apartment Homes",
  "property_website_url": "https://www.avignonapts.com/",
  "property_domain": "https://www.avignonapts.com/",
  "property_address": "11820 S Greenwood St",
  "property_full_address": "11820 S Greenwood St, Olathe, KS 66062",
  "property_address_1": "11820 S Greenwood St",
  "property_address_2": null,
  "property_address_city": "Olathe",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66062",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Avignon",
  "property_address_latitude": "38.9139893",
  "property_address_longitude": "-94.7529807",
  "property_email": "rentcafe.av@pricekc.com",
  "property_phone": "(913) 513-1489",
  "property_call_tracking_phone": "913-513-1489",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>European-inspired comfort in Olathe.</strong> Avignon Apartment Homes pairs spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with in-home laundry, private patios or balconies, and polished finishes—plus relaxing <a href=\"/amenities\">community spaces</a> designed to make everyday living feel effortless.</p>",
  "property_long_description": "Discover our premier apartment community, Avignon Apartment Homes in Olathe, KS, near Kansas City. This vibrant community in the Avignon neighborhood is close to high-end restaurants and local boutique stores. Our Olathe apartments are pet-friendly and the perfect home for professionals, students, families, seniors, and everyone in between. Please take a closer look at everything we have in store for you! When you choose one of our luxury apartments in Olathe, Kansas, you get more than a place to live - you get a place to relax and proudly call home. Each apartment home has been crafted with style and is fully equipped with built-in wine coolers, a washer, a dryer, and garden-size tubs. Whether you select one of our one, two, or three-bedroom Olathe luxury apartments, your experience will be just as sweet.Designed to create the perfect living environment, our luxury community offers an ambiance you will be happy to return to daily. With you in mind, we offer community amenities you will love, including a saltwater pool with outdoor loggia and private cabanas, a game room with billiards, darts, video games, steam rooms, and tanning beds, and we even offer massage therapy. Add in our helpful management team, and your apartment living experience becomes complete.Discover more when you come for a visit -- call today!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-be7d-70ef-9c0b-41d38eeb7298.webp",
  "property_featured_image_media": {
    "alt_text": "Covered outdoor patio seating area with turquoise cushions, ceiling fans, and stone columns.",
    "public_id": "01a01019-be7d-70ef-9c0b-41d38eeb7298",
    "storage_key": "property/6767906449167588/01a01019-be7d-70ef-9c0b-41d38eeb7298.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "307",
  "property_year_built": "2006",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.11400651465797",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://avignonapts.securecafeapplicant.com/onlineleasing/content3/access/avignon-apartment-homes/floorplans",
  "property_resident_portal_url": "https://avignonapts.securecafe.com/residentservices/avignon-apartment-homes/userlogin.aspx",
  "property_apply_now_url": "https://avignonapts.securecafeapplicant.com/onlineleasing/content3/access/avignon-apartment-homes/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0159c-315f-7352-80fb-519515b1d4fe.webp",
  "property_primary_logo_media": {
    "alt_text": "Avignon logo",
    "public_id": "01a0159c-315f-7352-80fb-519515b1d4fe",
    "storage_key": "property/6767906449167588/01a0159c-315f-7352-80fb-519515b1d4fe.webp",
    "width": 150,
    "height": 78
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0159c-7dda-72b4-8a1c-8e3871fdec6f.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0159c-7dda-72b4-8a1c-8e3871fdec6f",
    "storage_key": "property/6767906449167588/01a0159c-7dda-72b4-8a1c-8e3871fdec6f.webp",
    "width": 150,
    "height": 78
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0159c-72dc-77bf-976a-6fff45bd26a5.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0159c-72dc-77bf-976a-6fff45bd26a5",
    "storage_key": "property/6767906449167588/01a0159c-72dc-77bf-976a-6fff45bd26a5.webp",
    "width": 150,
    "height": 78
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4b5054",
  "property_secondary_color": "#b3a369",
  "property_font_color": null,
  "property_color_4": "#8B634B",
  "property_color_3": "#4F758B",
  "property_color_5": "#B594B6",
  "property_color_6": "#B3A168",
  "property_color_7": "#4B4F55",
  "property_color_8": "#8666AC",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "704 - 1384",
  "property_sqft_min": "704",
  "property_sqft_max": "1384",
  "property_price_range": "1675 - 8204",
  "property_price_min": "1675",
  "property_price_max": "8204",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/AvignonApts/",
  "property_instagram_url": "https://www.instagram.com/avignonapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ5yPtYRSVwIcR33wTJmfREyg",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Avignon Apartment Homes",
  "property_home_romance_title": "Embrace a Life of Love in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities that keep pace with real life.</strong> Avignon Apartment Homes brings focus, recharge, and resort-style downtime close to home with a Wi-Fi clubhouse, conference and business areas, fitness center, steam rooms, sauna, spa, tanning beds, and massage therapy. Outdoors, unwind beside the saltwater pool with cabanas, an open-air loggia, and spaces for dining and cooking. At home, enjoy washers and dryers, spacious closets, garden tubs, upgraded finishes, and select extras like attached garages, dens, and built-in wine coolers.</p>",
  "property_home_floorplans_blurb": "<p><strong>One-, two-, and three-bedroom layouts with standout extras.</strong> Avignon Apartment Homes pairs everyday ease with polished details, from in-unit washers and dryers, spacious closets, and private patios or balconies to select upgraded kitchens with stainless steel appliances, stone backsplash, or a built-in wine cooler. Explore options with dens or studies, attached garages, island kitchens, garden tubs, and added storage, then find the floor plan that fits your space best.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the Avignon experience.</strong> Step inside bright living areas, polished kitchens, inviting dining spaces, and select homes with built-in desk space, library niches, and patios or balconies. Then picture the community beyond your door, from the resort-style pool with cabanas to the outdoor loggia and clubroom with billiards, coffee, and space to gather. Browse the gallery for a closer look.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Olathe stays close from Avignon.</strong> Start with coffee or errands near 119th Street, then head toward Olathe Station for dining, movies, and shopping. I-35, Strang Line Park &amp; Ride, and RideKC routes keep the wider Kansas City area within reach, while Thomas S. Stoll Memorial Park, Mahaffie Stagecoach Stop &amp; Farm, Main Event, and AMC DINE-IN Studio 28 add easy options nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about life at Avignon.</strong> Reviews point to friendly office support, quick maintenance, cared-for green spaces, and a welcoming community feel. Team members like Lauren and Ronnell earn shoutouts for helpful service, while comfortable apartment homes, monthly events, pet-friendly outdoor areas, and a convenient Olathe location keep showing up in the feedback. Read the reviews to hear it firsthand.</p>",
  "property_neighborhood_blurb": "<p><strong>Life here puts Olathe within easy reach.</strong> From Avignon, your day can move from coffee and errands near 119th Street to dinner, a movie, or a little retail time along the Olathe Station corridor. I-35 is close for cross-metro plans, while Strang Line Park &amp; Ride and RideKC routes add another way to connect around Johnson County and Kansas City.</p><p>When you want fresh air or local flavor, head toward Thomas S. Stoll Memorial Park for trails and open space, visit Mahaffie Stagecoach Stop &amp; Farm for a piece of Olathe history, or make a quick outing to Main Event, Bass Pro Shops, or AMC DINE-IN Studio 28. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Avignon connects home with the best of northeast Olathe.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Make more room for the way your day actually flows.</strong> At Avignon Apartment Homes in Olathe, amenities go beyond the basics with spaces for focus, recharge, and gathering close to home. Start in the clubhouse with Wi-Fi, coffee, conference rooms, and business areas, then shift to the fitness center, lockers, steam rooms, sauna, spa, tanning beds, or massage therapy when it is time to reset.</p><p>Outside, the saltwater pool feels like a destination, with private cabanas, an outdoor loggia, and dining and cooking areas made for easy afternoons. Inside your apartment, everyday convenience comes through in-home washer and dryer, spacious closets, garden tubs, upgraded finishes, and select homes with attached garages, dens, stone backsplashes, or built-in wine coolers. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Avignon Apartment Homes.</strong><br>European-inspired comfort meets everyday Olathe convenience with one-, two-, and three-bedroom floor plans, in-home washer and dryer, spacious closets, private patios or balconies, and upgraded finishes. Apply online today and take the next step toward calling Avignon home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact the Avignon Apartment Homes leasing team for details on our European-inspired one-, two-, and three-bedroom apartments, everyday Olathe convenience, and location near 119th Street and I-35. We’re here to help you plan your next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Avignon Apartment Homes?</strong> Start here for quick answers about the community, leasing, floor plans, amenities, and everyday living in Olathe. If you don’t see what you need, the leasing team is happy to help you find the details and next steps.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you like to live.</strong> Avignon Apartment Homes offers one-, two-, and three-bedroom apartments in Olathe, with options that range from streamlined single-bedroom homes to roomier two-bath designs and select layouts with a den or study. As you compare floor plan cards, look for the details that make daily routines feel easier: in-unit washer and dryer, spacious closets, private patios or balconies, garden tubs, and upgraded kitchens with features like stainless steel appliances, stone backsplash, or a built-in wine cooler in select homes.</p><p>Need extra function? Select homes add attached garages, library niches, island kitchens, or added storage, giving you more ways to shape your space. Browse current pricing and availability below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details that make Avignon feel distinctive.</strong> Browse photos of bright living spaces, polished kitchens, and inviting dining areas with thoughtful touches like built-in desk space, library niches, and private patios or balconies in select homes.</p><p>The gallery also gives you a closer look at the community spaces that shape the experience: a resort-style pool framed by cabanas and lounge seating, an outdoor loggia made for slow afternoons, and clubroom spaces with billiards, coffee, and room to gather. From spa-inspired bath details to sunny outdoor corners, each image helps you picture the setting before you visit.</p><p>Like what you see? Explore more <a href=\"/amenities\">community amenities</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to view Avignon Apartment Homes in Olathe in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Avignon from every angle.</strong> Use the interactive map to browse available one-, two-, and three-bedroom apartments, then see how this Olathe location near 119th Street and I-35 connects you to nearby shopping, dining, parks, campuses, and medical centers.</p>",
  "property_pets_blurb": "<p><strong>Room for the whole crew—paws, whiskers, and all.</strong> At Avignon Apartment Homes, your pet’s routine fits right into yours, with cats, dogs, and rabbits welcomed under the community pet guidelines. Step out for fresh air along the walking and biking trails, linger in the courtyard or picnic areas, or choose a home with a private patio or balcony for an easy outdoor pause between walks.</p><p>In Olathe’s Avignon neighborhood, pet errands stay simple with grooming and supplies close by, while Heritage Park’s off-leash area gives dogs more room to run when adventure calls. Explore our <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to picture everyday life with your companion at Avignon.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Avignon experience.</strong> If European-inspired comfort, polished <a href=\"/amenities\">amenities</a>, and everyday Olathe convenience make Avignon feel like home, invite a friend to see it for themselves. Send a referral and help them discover thoughtfully designed <a href=\"/floor-plans\">one-, two-, and three-bedroom floor plans</a> at Avignon Apartment Homes.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Avignon Apartment Homes</strong><br>Everyday convenience continues online. Log in to pay rent, submit maintenance requests, and manage your account from the comfort of home—whether you’re in a one-, two-, or three-bedroom layout with the polished features that make Avignon feel effortless.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Avignon Apartment Homes.</strong> Reviews highlight the everyday details that make a difference: friendly office support, responsive maintenance, well-kept green spaces, and a genuine sense of connection throughout the community.</p><p>Residents often call out team members by name, from Lauren’s “above and beyond” welcome at the front desk to Ronnell’s helpful, professional approach to service requests. You’ll also see praise for comfortable apartment homes, monthly events, pet-friendly outdoor areas, and a location residents describe as convenient. Browse the reviews below to hear firsthand what life at Avignon feels like.</p>",
  "property_created_at": "1785785797345",
  "property_scheduletour_blurb": "<p><strong>See Avignon Apartment Homes in person.</strong><br>Tour European-inspired one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with spacious closets, private patios or balconies, garden tubs, and upgraded finishes, then picture everyday downtime by the saltwater pool, clubhouse, spa, and more. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Avignon Apartment Homes.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture European-inspired comfort in Olathe with thoughtfully designed floor plans, in-home conveniences, polished finishes, and inviting spaces to relax, recharge, and feel at home.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through the layouts before you visit.</strong> Avignon’s virtual tours let you move room by room through the apartment styles available to explore online: A1 Petit, A2 Rhone, A3 Carmes, B1 Calvert, B2 Cheval, B3 Avignon, and C1 Provence. Compare one-, two-, and three-bedroom options from anywhere, pausing on the details that matter most—open living areas, polished kitchens, spacious closets, private outdoor space, and select extras like a den/study or built-in wine cooler.</p><p>Use each 360° walkthrough to get a clearer feel for flow, storage, finishes, and where your furniture could fit, then match your favorites with current <a href=\"/floor-plans\">floor plan options</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Avignon Apartment Homes in Olathe in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Avignon Apartment Homes",
  "property_seo_title_home": "Olathe Apartment Complexes | Avignon Apartment Homes",
  "property_seo_description_home": "Avignon Apartment Homes offers luxury 1, 2 & 3-bedroom apartments in Olathe, KS with a saltwater pool, fitness center, and game room. Tour today!",
  "property_seo_title_floorplans": "1, 2 & 3-Bedroom Apartments in Olathe, KS | Avignon",
  "property_seo_description_floorplans": "Explore floor plans at Avignon Apartment Homes in Olathe, KS, from 704 to 1,384 sq ft with wine coolers, garden tubs, and in-unit laundry. Tour today!",
  "property_seo_title_amenities": "Luxury Apartment Amenities in Olathe, KS | Avignon",
  "property_seo_description_amenities": "Explore Avignon Apartment Homes amenities in Olathe, KS, including a saltwater pool, fitness center, business center, and pet-friendly policies.",
  "property_seo_title_gallery": "Apartments for Rent in Olathe, KS | Photo Gallery",
  "property_seo_description_gallery": "Browse photos of apartment interiors, the saltwater pool, and game room at Avignon Apartment Homes in Olathe, KS. Schedule your tour today!",
  "property_seo_title_virtualtours": "Virtual Tours | Avignon Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Avignon Apartment Homes in Olathe, KS! Take a virtual tour today and explore spacious one, two, and three-bedroom floor plans tailored for you!",
  "property_seo_title_interactivemap": "Interactive Property Map | Avignon Apartment Homes",
  "property_seo_description_interactivemap": "Use the Avignon Apartment Homes interactive property map to browse available 1, 2 & 3-bedroom apartments in Olathe, KS by floor plan and price.",
  "property_seo_title_neighborhood": "Apartments Near JCCC in Olathe, KS 66062",
  "property_seo_description_neighborhood": "Avignon Apartment Homes sits minutes from JCCC, Overland Park, and local shops in Olathe, KS 66062. Explore the neighborhood and tour today!",
  "property_seo_title_contact": "Contact Avignon Apartment Homes | Olathe, KS",
  "property_seo_description_contact": "Contact Avignon Apartment Homes in Olathe, KS to ask about floor plans, pricing, amenities, or scheduling a tour of our community.",
  "property_seo_title_faqs": "Frequently Asked Questions | Avignon Apartments",
  "property_seo_description_faqs": "Find answers about applications, deposits, pets, utilities, rent payments, and maintenance at Avignon Apartment Homes in Olathe, KS.",
  "property_seo_title_reviews": "Resident Reviews | Avignon Apartment Homes",
  "property_seo_description_reviews": "Read reviews from residents of Avignon Apartment Homes in Olathe, KS and see why renters choose our pet-friendly community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Olathe, KS",
  "property_seo_description_applynow": "Experience luxury living at Avignon Apartment Homes in Olathe, KS! Browse spacious floor plans, enjoy top-notch amenities, and lease your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Avignon Apartment Homes",
  "property_seo_description_residentaccess": "Unlock the convenience of Avignon Apartment Homes. Access your resident portal for rent payments, maintenance requests, and exclusive community features.",
  "property_seo_title_referafriend": "Refer A Friend | Avignon Apartment Homes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Avignon Apartment Homes in Olathe, KS, and share the joy of comfortable living in a vibrant community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Avignon Apartment Homes",
  "property_seo_description_scheduletour": "Schedule a tour of Avignon Apartment Homes in Olathe, KS and see our 1, 2 & 3-bedroom apartments, saltwater pool, and fitness center in person.",
  "property_seo_title_privacy": "Privacy Policy | Avignon Apartment Homes",
  "property_seo_description_privacy": "At Avignon Apartment Homes in Olathe, KS, your privacy matters. Review our commitment to protecting your personal information. Stay informed today!",
  "property_seo_title_accessibility": "Website Accessibility | Avignon Apartment Homes",
  "property_seo_description_accessibility": "At Avignon Apartment Homes in Olathe, KS, we prioritize accessibility for all. Learn how we promote digital inclusion for a welcoming community experience.",
  "property_seo_title_sitemap": "Sitemap | Avignon Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Avignon Apartment Homes in Olathe, KS. Check out our sitemap to find your ideal living space today!",
  "property_seo_title_thankyou": "Thank You | Avignon Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Avignon Apartment Homes in Olathe! Our team will connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Olathe, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793646107834",
  "amenities": [
    {
      "id": "ec_f63a2ca9ca0e6427b91e833b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121464",
      "title": "Elegant Salt Water Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-9605-75af-a508-7beaf1ff3934.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas.",
        "public_id": "01a01019-9605-75af-a508-7beaf1ff3934",
        "storage_key": "property/6767906449167588/01a01019-9605-75af-a508-7beaf1ff3934.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A large swimming pool surrounded by sun loungers and umbrellas. at Avignon Apartment Homes, Olathe, Kansas,A large swimming pool surrounded by lounge chairs and trees at Avignon Apartment Homes, Olathe 66062,A swimming pool in a residential area with a clear blue sky at Avignon Apartment Homes, Olathe, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c1d6e94759f497c78396111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121456",
      "title": "State-of-the-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce903aee67922e6f98e7f627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121454",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23f61f8b2d56b0e7e5775b8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121462",
      "title": "Outdoor Dining and Cooking Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-851a-73ff-9e73-7bc967759599.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor built-in grill area with stone accents",
        "public_id": "01a01019-851a-73ff-9e73-7bc967759599",
        "storage_key": "property/6767906449167588/01a01019-851a-73ff-9e73-7bc967759599.webp",
        "width": 1200,
        "height": 801
      },
      "amenity_image_alt_text": "Outdoor Dining and Cooking Areas at Avignon Apartment Homes, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a1b2deae24685d4a8f18b73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121463",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-845a-754d-a382-5e2568602473.webp",
      "amenity_image_media": {
        "alt_text": "Lobby with fireplace, seating area, and coffee station",
        "public_id": "01a01019-845a-754d-a382-5e2568602473",
        "storage_key": "property/6767906449167588/01a01019-845a-754d-a382-5e2568602473.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Clubhouse at Avignon Apartment Homes, Olathe, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdf3b9b5989ee71ad67bd90d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121455",
      "title": "Full-time Concierge Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8aef46984474cc981b8fec96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121467",
      "title": "Private Pool Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-aca1-72bc-9552-8afa8279560e.webp",
      "amenity_image_media": {
        "alt_text": "An inviting swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a01019-aca1-72bc-9552-8afa8279560e",
        "storage_key": "property/6767906449167588/01a01019-aca1-72bc-9552-8afa8279560e.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A pool area with a striped canopy over it at Avignon Apartment Homes, Kansas, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e52caa31639ae99a5e1c63b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121460",
      "title": "Outdoor Loggia",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-be7d-70ef-9c0b-41d38eeb7298.webp",
      "amenity_image_media": {
        "alt_text": "Covered outdoor patio seating area with turquoise cushions, ceiling fans, and stone columns.",
        "public_id": "01a01019-be7d-70ef-9c0b-41d38eeb7298",
        "storage_key": "property/6767906449167588/01a01019-be7d-70ef-9c0b-41d38eeb7298.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A patio with blue chairs and a table with a flower vase on it. at Avignon Apartment Homes, Kansas,A table is on a patio with a blue couch and a fan. at Avignon Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39d6a71e7670bbbe3a35d82d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121458",
      "title": "Lockers and Shower Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8db049a0f38020bcc8775610",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "123610432",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-9014-73cf-9a5f-08f8b1a9f020.webp",
      "amenity_image_media": {
        "alt_text": "Conference room with oval table and chairs, exit sign, and large mirror.",
        "public_id": "01a01019-9014-73cf-9a5f-08f8b1a9f020",
        "storage_key": "property/6767906449167588/01a01019-9014-73cf-9a5f-08f8b1a9f020.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Conference Room at Avignon Apartment Homes, Olathe, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9304f3922c5c4309ed61d2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121465",
      "title": "Game Room with Billiards, Darts, and Video Games",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48da6f56fd3f76baccb0f8c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121459",
      "title": "Event Space with Prep Kitchen & Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14a1d99ddd81870fc34403ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121466",
      "title": "Massage Therapy",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ee0edc864048a0377a514b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121461",
      "title": "Tanning Beds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_695cf0654f94e632bf4ce97c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121468",
      "title": "Steam Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c07bc78cc59265b3569db9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "106912864",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc5bfff9efdb4516c3f800e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121469",
      "title": "Wi-Fi Access in Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c66d8c696b02f72a6b3b071",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "122755344",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_976a50b63bb6bcfffeb952cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121478",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-c89f-76fb-a26e-3f2dac80164c.webp",
      "amenity_image_media": {
        "alt_text": "White GE washer and dryer in a small laundry closet with a wire shelf.",
        "public_id": "01a01019-c89f-76fb-a26e-3f2dac80164c",
        "storage_key": "property/6767906449167588/01a01019-c89f-76fb-a26e-3f2dac80164c.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "Two white front loading washing machines in a small laundry room. at Avignon Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfed24f1fb426fb7e3e4885e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121471",
      "title": "Private Balconies and Patios",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-9c95-7298-af2a-169ae0a868de.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with table and chairs, overlooking a courtyard and apartment buildings.",
        "public_id": "01a01019-9c95-7298-af2a-169ae0a868de",
        "storage_key": "property/6767906449167588/01a01019-9c95-7298-af2a-169ae0a868de.webp",
        "width": 3000,
        "height": 2009
      },
      "amenity_image_alt_text": "A spacious, fenced-in patio overlooking a grassy area. at Avignon Apartment Homes, Olathe, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62c8856daa376dc411e375a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121470",
      "title": "Upgraded Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-b64d-761f-beec-06fcbc7f8e00.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and granite countertops.",
        "public_id": "01a01019-b64d-761f-beec-06fcbc7f8e00",
        "storage_key": "property/6767906449167588/01a01019-b64d-761f-beec-06fcbc7f8e00.webp",
        "width": 2917,
        "height": 1945
      },
      "amenity_image_alt_text": "A kitchen with updated stainless steel appliances and a kitchen island. at Avignon Apartment Homes, Kansas, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ded969f4578b2036a2ce112",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121477",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aeaf3d702f848a17de8e54a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88143696",
      "title": "Attached 1 Car Garage*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81377c850baeffd85131a501",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88143697",
      "title": "Attached 2 Car Garage*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ca351ae9b02c6003857187a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121472",
      "title": "Built-in Wine Cooler",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-c57a-735c-8984-9b3fb3c45f24.webp",
      "amenity_image_media": {
        "alt_text": "Open-concept living space with a modern kitchen island, dining area, and living room.",
        "public_id": "01a01019-c57a-735c-8984-9b3fb3c45f24",
        "storage_key": "property/6767906449167588/01a01019-c57a-735c-8984-9b3fb3c45f24.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with a refrigerator, a table, and a clock on the wall. at Avignon Apartment Homes, Olathe 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41eaad051514485f39cc4353",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121473",
      "title": "Den/Study*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61963d684fa4b9ff1840bba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121479",
      "title": "Library Niche*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-eb04-73e4-a9ab-9b809b891b6c.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a large bed, nightstand, ceiling fan, and seating area with two chairs and a small table.",
        "public_id": "01a01019-eb04-73e4-a9ab-9b809b891b6c",
        "storage_key": "property/6767906449167588/01a01019-eb04-73e4-a9ab-9b809b891b6c.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A bedroom with a large bed, ceiling fan, and library niche. at Avignon Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_994125b98cf26a2b6e3f6265",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121476",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-ec36-7238-a97f-20e4c2b4b5ea.webp",
      "amenity_image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower.",
        "public_id": "01a01019-ec36-7238-a97f-20e4c2b4b5ea",
        "storage_key": "property/6767906449167588/01a01019-ec36-7238-a97f-20e4c2b4b5ea.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A bathroom with a toilet, sink, and shower. at Avignon Apartment Homes, Olathe",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f30386cb5e8baa5e500ecf68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121474",
      "title": "Hardwood Entryway",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-c57a-735c-8984-9b3fb3c45f24.webp",
      "amenity_image_media": {
        "alt_text": "Open-concept living space with a modern kitchen island, dining area, and living room.",
        "public_id": "01a01019-c57a-735c-8984-9b3fb3c45f24",
        "storage_key": "property/6767906449167588/01a01019-c57a-735c-8984-9b3fb3c45f24.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen with a kitchen island, wine cooler, hardwood floors, and a living space in the background at Avignon Apartment Homes, Olathe, KS, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1345c59178f94dd71352048d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "88121475",
      "title": "Crown Molding",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-f847-71ef-b86d-ee38499d4517.webp",
      "amenity_image_media": {
        "alt_text": "Living and dining area with a sectional sofa, coffee table, and dining set.",
        "public_id": "01a01019-f847-71ef-b86d-ee38499d4517",
        "storage_key": "property/6767906449167588/01a01019-f847-71ef-b86d-ee38499d4517.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A well-lit dining area with a round table and chairs. at Avignon Apartment Homes, Olathe, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a07df97051014d420ba4d1a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "121428922",
      "title": "Stone Backsplash*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-b64d-761f-beec-06fcbc7f8e00.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and granite countertops.",
        "public_id": "01a01019-b64d-761f-beec-06fcbc7f8e00",
        "storage_key": "property/6767906449167588/01a01019-b64d-761f-beec-06fcbc7f8e00.webp",
        "width": 2917,
        "height": 1945
      },
      "amenity_image_alt_text": "A kitchen with updated stainless steel appliances, stone backsplash and a kitchen island. at Avignon Apartment Homes, Kansas, 66062",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9643f34d5ef94bf57ce53337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "external_id": "121428924",
      "title": "Upgraded Fixtures",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3362623ac7efcfc0b09a6f87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-1592-750f-8cb5-1f3331e7bf5f.webp",
      "image_media": {
        "alt_text": "Spacious living area with island, dining table, and desk.",
        "public_id": "01a0101a-1592-750f-8cb5-1f3331e7bf5f",
        "storage_key": "property/6767906449167588/01a0101a-1592-750f-8cb5-1f3331e7bf5f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space featuring a kitchen island, a separate dining area, and a dedicated workspace. Perfect for modern living.",
      "link": "false",
      "alt_text": "Spacious living area with island, dining table, and desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-11820 S Greenwood St -13.jpg"
    },
    {
      "id": "ec_48d28e4eab639328442991ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-158a-750c-9b33-d37c4b203028.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space.",
        "public_id": "01a0101a-158a-750c-9b33-d37c4b203028",
        "storage_key": "property/6767906449167588/01a0101a-158a-750c-9b33-d37c4b203028.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and well-equipped kitchen featuring stainless steel appliances, granite countertops, and elegant wood cabinetry, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-11820 S Greenwood St -14.jpg"
    },
    {
      "id": "ec_3f650047adf9b4c28c714424",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a03cac-d309-76ff-af69-f7b016d57938.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a view of the kitchen.",
        "public_id": "01a03cac-d309-76ff-af69-f7b016d57938",
        "storage_key": "property/6767906449167588/01a03cac-d309-76ff-af69-f7b016d57938.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area seamlessly connected to a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Open-concept living and dining area with a view of the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/avignon_livingroom_diningroom_interior.png"
    },
    {
      "id": "ec_f68dca8bce16a4517b688f51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-151e-77fc-b1f6-a7de26e375e6.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, two nightstands, and two chairs in a sitting area by the window.",
        "public_id": "01a0101a-151e-77fc-b1f6-a7de26e375e6",
        "storage_key": "property/6767906449167588/01a0101a-151e-77fc-b1f6-a7de26e375e6.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bedroom featuring a comfortable bed, elegant decor, and a cozy seating area by the window, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a bed, two nightstands, and two chairs in a sitting area by the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-11820 S Greenwood St -7.jpg"
    },
    {
      "id": "ec_344a19f78858bbf24f26c333",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-151b-729d-b73e-df4d0ae57dca.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, ceiling fan, and large TV.",
        "public_id": "01a0101a-151b-729d-b73e-df4d0ae57dca",
        "storage_key": "property/6767906449167588/01a0101a-151b-729d-b73e-df4d0ae57dca.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, elegant decor, and a ceiling fan, with a view into the bathroom and living area.",
      "link": "false",
      "alt_text": "Bedroom with king-size bed, ceiling fan, and large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-11820 S Greenwood St -9.jpg"
    },
    {
      "id": "ec_66a86f319a563d346fd3d41a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-153a-715b-b93b-4c682630c079.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-sized bed, sitting area, and mounted TV.",
        "public_id": "01a0101a-153a-715b-b93b-4c682630c079",
        "storage_key": "property/6767906449167588/01a0101a-153a-715b-b93b-4c682630c079.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "This inviting bedroom features a plush king-sized bed, a cozy sitting area by the window, and a large mounted TV for your entertainment. Enjoy ample space and comfort.",
      "link": "false",
      "alt_text": "Spacious bedroom with a king-sized bed, sitting area, and mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-11820 S Greenwood St -8.jpg"
    },
    {
      "id": "ec_d2f072dbb5a390f37ba6ffb2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-23c2-733a-a6d2-ccf6b4437a3f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances, opening to living room and balcony.",
        "public_id": "01a0101a-23c2-733a-a6d2-ccf6b4437a3f",
        "storage_key": "property/6767906449167588/01a0101a-23c2-733a-a6d2-ccf6b4437a3f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a gourmet kitchen with a large island, granite countertops, and stainless steel appliances, seamlessly flowing into the living room with access to a private balcony.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances, opening to living room and balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/36-DSC07394.jpg"
    },
    {
      "id": "ec_0aa957e8dabb7816e02b6b98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-20b5-7309-a258-b284327386ab.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wooden vanity, white tile shower and tub, and glass shower door.",
        "public_id": "01a0101a-20b5-7309-a258-b284327386ab",
        "storage_key": "property/6767906449167588/01a0101a-20b5-7309-a258-b284327386ab.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and style of this modern bathroom, featuring a spacious vanity, a clean white tiled shower and tub combination, and a sleek glass-enclosed shower.",
      "link": "false",
      "alt_text": "Modern bathroom with wooden vanity, white tile shower and tub, and glass shower door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-11820 S Greenwood St -17.jpg"
    },
    {
      "id": "ec_ea8b0364c11d4c73e6b3c209",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-2191-729e-b085-0b51e433a29e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and wooden cabinets next to a glass-enclosed shower.",
        "public_id": "01a0101a-2191-729e-b085-0b51e433a29e",
        "storage_key": "property/6767906449167588/01a0101a-2191-729e-b085-0b51e433a29e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a single vanity with ample storage and a spacious, glass-enclosed shower with white tiled walls.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and wooden cabinets next to a glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-DSC07470.jpg"
    },
    {
      "id": "ec_0463febf3747c9bbc7933795",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a02819-a2a5-71cf-8883-d1ffc90329d5.webp",
      "image_media": {
        "alt_text": "Hallway with carpet, neutral walls, and a closed door.",
        "public_id": "01a02819-a2a5-71cf-8883-d1ffc90329d5",
        "storage_key": "property/6767906449167588/01a02819-a2a5-71cf-8883-d1ffc90329d5.webp",
        "width": 1448,
        "height": 1086
      },
      "title": "Apartment",
      "description": "A cozy hallway with plush carpeting, neutral-toned walls, and a closed door leading to another room.",
      "link": "false",
      "alt_text": "Hallway with carpet, neutral walls, and a closed door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/ChatGPT Image Aug 20, 2026, 12_02_09 PM.png"
    },
    {
      "id": "ec_6fcd84955c555ee768049bd1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-2476-765c-9a99-43e45b84e30f.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer unit in an apartment laundry room.",
        "public_id": "01a0101a-2476-765c-9a99-43e45b84e30f",
        "storage_key": "property/6767906449167588/01a0101a-2476-765c-9a99-43e45b84e30f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access.",
      "link": "false",
      "alt_text": "Stackable washer and dryer unit in an apartment laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-DSC07300.jpg"
    },
    {
      "id": "ec_d633104e6bbe07bcde60e9d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-29c0-7303-ba22-e5e713d61ae9.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, green throw, and two lamps.",
        "public_id": "01a0101a-29c0-7303-ba22-e5e713d61ae9",
        "storage_key": "property/6767906449167588/01a0101a-29c0-7303-ba22-e5e713d61ae9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, elegant decor, and ample natural light from large windows. Perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, green throw, and two lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-11820 S Greenwood St -15.jpg"
    },
    {
      "id": "ec_155825318ea5b3bda29ad9fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-2b19-7138-985d-cdcdb0cf614d.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, green blanket, and view into bathroom.",
        "public_id": "01a0101a-2b19-7138-985d-cdcdb0cf614d",
        "storage_key": "property/6767906449167588/01a0101a-2b19-7138-985d-cdcdb0cf614d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-sized bed with plush linens, accented by a stylish green throw blanket and decorative pillows.",
      "link": "false",
      "alt_text": "Bedroom with queen bed, green blanket, and view into bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-11820 S Greenwood St -16.jpg"
    },
    {
      "id": "ec_232f3495a887e200865eba3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-2d75-70c0-966b-a84fae0a067e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances.",
        "public_id": "01a0101a-2d75-70c0-966b-a84fae0a067e",
        "storage_key": "property/6767906449167588/01a0101a-2d75-70c0-966b-a84fae0a067e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring a large island, stainless steel appliances, ample cabinet space, and elegant backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/34-DSC07380.jpg"
    },
    {
      "id": "ec_c5f4f1d545066fa2f212db1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-2d4d-756b-89a6-2dde899fddf9.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, mounted TV, and an ensuite bathroom visible through an open doorway.",
        "public_id": "01a0101a-2d4d-756b-89a6-2dde899fddf9",
        "storage_key": "property/6767906449167588/01a0101a-2d4d-756b-89a6-2dde899fddf9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, a wall-mounted TV above a sleek media console, and convenient access to an ensuite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a ceiling fan, mounted TV, and an ensuite bathroom visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-11820 S Greenwood St -10.jpg"
    },
    {
      "id": "ec_18e88fd86ef72b7fed7dc190",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-3350-709e-a9c4-e904bc89766f.webp",
      "image_media": {
        "alt_text": "Double vanity with two sinks and ample counter space, leading to a spacious walk-in closet.",
        "public_id": "01a0101a-3350-709e-a9c4-e904bc89766f",
        "storage_key": "property/6767906449167588/01a0101a-3350-709e-a9c4-e904bc89766f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with two sinks and a large walk-in closet, offering plenty of storage.",
      "link": "false",
      "alt_text": "Double vanity with two sinks and ample counter space, leading to a spacious walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-DSC07189.jpg"
    },
    {
      "id": "ec_b03eb4a7ab10fe20f5699b48",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-3544-7553-bc45-cc396cd1baa1.webp",
      "image_media": {
        "alt_text": "Balcony with outdoor dining set overlooking apartments and green lawn.",
        "public_id": "01a0101a-3544-7553-bc45-cc396cd1baa1",
        "storage_key": "property/6767906449167588/01a0101a-3544-7553-bc45-cc396cd1baa1.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with an outdoor dining set. This space offers a perfect extension of your apartment living.",
      "link": "false",
      "alt_text": "Balcony with outdoor dining set overlooking apartments and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-11820 S Greenwood St -11.jpg"
    },
    {
      "id": "ec_4fdce41a0b343274ec7cbc53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-3607-71fc-b538-25aa619cef19.webp",
      "image_media": {
        "alt_text": "Modern living and dining room with green sectional sofa and round marble dining table.",
        "public_id": "01a0101a-3607-71fc-b538-25aa619cef19",
        "storage_key": "property/6767906449167588/01a0101a-3607-71fc-b538-25aa619cef19.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a plush green sectional sofa, a marble-top dining table with four chairs, and a built-in desk with cabinetry.",
      "link": "false",
      "alt_text": "Modern living and dining room with green sectional sofa and round marble dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-11820 S Greenwood St -5.jpg"
    },
    {
      "id": "ec_c45f600e64a784776529f75c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-8685-70c8-8eda-96c7a2ca9c22.webp",
      "image_media": {
        "alt_text": "Avignon apartment building exterior with stone facade and entrance.",
        "public_id": "01a0101a-8685-70c8-8eda-96c7a2ca9c22",
        "storage_key": "property/6767906449167588/01a0101a-8685-70c8-8eda-96c7a2ca9c22.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Avignon apartments, featuring charming architecture and beautiful landscaping.",
      "link": "false",
      "alt_text": "Avignon apartment building exterior with stone facade and entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-DSC01371.jpg"
    },
    {
      "id": "ec_493467e53eb4bc69138cb7ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01024-f8f2-75cf-ab62-4ef39dd133fe.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas on a sunny day.",
        "public_id": "01a01024-f8f2-75cf-ab62-4ef39dd133fe",
        "storage_key": "property/6767906449167588/01a01024-f8f2-75cf-ab62-4ef39dd133fe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded cabanas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-DSC01525.jpg"
    },
    {
      "id": "ec_c1bf1318b24a99eec11dcb0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01024-f8ff-716e-a85d-809ad2039351.webp",
      "image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and a cabana, surrounded by lush greenery and apartment buildings.",
        "public_id": "01a01024-f8ff-716e-a85d-809ad2039351",
        "storage_key": "property/6767906449167588/01a01024-f8ff-716e-a85d-809ad2039351.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, perfect for relaxing or entertaining. Lounge chairs and cabanas provide ample space to unwind under the sun.",
      "link": "false",
      "alt_text": "An inviting outdoor swimming pool with lounge chairs and a cabana, surrounded by lush greenery and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-DSC01545.jpg"
    },
    {
      "id": "ec_b1ec518f5f76d05afbb8dbe9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101a-7765-74a7-bb34-d87f59f7296b.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with umbrellas and a water feature in the courtyard of an apartment complex.",
        "public_id": "01a0101a-7765-74a7-bb34-d87f59f7296b",
        "storage_key": "property/6767906449167588/01a0101a-7765-74a7-bb34-d87f59f7296b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the beautiful courtyard with comfortable outdoor seating and a serene water feature. Perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "Outdoor seating area with umbrellas and a water feature in the courtyard of an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-DSC01695.jpg"
    },
    {
      "id": "ec_43e43bb8c4cf8ab314cbe0da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01024-f95c-76d9-9e49-1c880da62678.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with teal seating and stone pillars.",
        "public_id": "01a01024-f95c-76d9-9e49-1c880da62678",
        "storage_key": "property/6767906449167588/01a01024-f95c-76d9-9e49-1c880da62678.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor lounge area, featuring plush seating and a cozy atmosphere perfect for enjoying the fresh air.",
      "link": "false",
      "alt_text": "Covered outdoor lounge area with teal seating and stone pillars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-DSC01762.jpg"
    },
    {
      "id": "ec_d0e3db0b2ab6f6ea88331c84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01024-f95f-77eb-b82f-cfa7ad2266f5.webp",
      "image_media": {
        "alt_text": "Covered patio with ping pong table and outdoor seating.",
        "public_id": "01a01024-f95f-77eb-b82f-cfa7ad2266f5",
        "storage_key": "property/6767906449167588/01a01024-f95f-77eb-b82f-cfa7ad2266f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation on the covered patio, complete with a ping pong table and comfortable outdoor seating.",
      "link": "false",
      "alt_text": "Covered patio with ping pong table and outdoor seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-DSC01792.jpg"
    },
    {
      "id": "ec_66442d0e1ad6e587e38c3409",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-851a-73ff-9e73-7bc967759599.webp",
      "image_media": {
        "alt_text": "Outdoor built-in grill area with stone accents",
        "public_id": "01a01019-851a-73ff-9e73-7bc967759599",
        "storage_key": "property/6767906449167588/01a01019-851a-73ff-9e73-7bc967759599.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and entertaining at our community grill station, featuring a stainless steel grill and convenient refrigerator.",
      "link": "false",
      "alt_text": "Outdoor built-in grill area with stone accents",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/3-11820 S Greenwood St-3.jpg"
    },
    {
      "id": "ec_ab2070e519fed1f100230f62",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-9014-73cf-9a5f-08f8b1a9f020.webp",
      "image_media": {
        "alt_text": "Conference room with oval table and chairs, exit sign, and large mirror.",
        "public_id": "01a01019-9014-73cf-9a5f-08f8b1a9f020",
        "storage_key": "property/6767906449167588/01a01019-9014-73cf-9a5f-08f8b1a9f020.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "A well-appointed conference room featuring a polished wood table, executive chairs, and a decorative mirror, ideal for business meetings.",
      "link": "false",
      "alt_text": "Conference room with oval table and chairs, exit sign, and large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/2-11820 S Greenwood St-2(1).jpg"
    },
    {
      "id": "ec_a296fa9709f3c459db28e187",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a01019-845a-754d-a382-5e2568602473.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace, seating area, and coffee station",
        "public_id": "01a01019-845a-754d-a382-5e2568602473",
        "storage_key": "property/6767906449167588/01a01019-845a-754d-a382-5e2568602473.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax in our beautifully appointed lobby, featuring a cozy fireplace, comfortable seating, and a convenient coffee station.",
      "link": "false",
      "alt_text": "Lobby with fireplace, seating area, and coffee station",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/1-11820 S Greenwood St-1.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3e2f3586-9dce-4cb4-8e56-7f556e954666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Mi Ranchito",
      "poi_type": "Restaurants",
      "poi_address": "14154 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Local cantina chain serving classic Mexican dishes & margaritas in a relaxed setting.",
      "poi_long_description": "Local cantina chain serving classic Mexican dishes & margaritas in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-2b6c-7295-bf2a-370d4e070467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-2b6c-7295-bf2a-370d4e070467",
        "storage_key": "property/6767906449167588/019fc924-2b6c-7295-bf2a-370d4e070467.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.miranchitokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4602316995990438706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-ranchito",
      "poi_latitude": "38.9132892",
      "poi_longitude": "-94.7498362",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-780-1717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-UcWhWVwIcRMsPAeey23j8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3ab2ea87-ef56-443e-9dcf-6ec0f36faff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "15289 W 119th St C-05, Olathe, KS 66062, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-a6e8-7628-a4fd-151cd0fa3dc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-a6e8-7628-a4fd-151cd0fa3dc7",
        "storage_key": "property/6767906449167588/01a0101d-a6e8-7628-a4fd-151cd0fa3dc7.webp",
        "width": 1280,
        "height": 995
      },
      "poi_business_url": "https://www.firstwatch.com/locations/olathe/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=11890966306310199220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "38.9099588",
      "poi_longitude": "-94.761764",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-390-6072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQ2ZG3OVwIcRtBfCw9oyBaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_c7955f46-3e60-4912-ac30-f442116fa4f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "14605 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-abae-72bf-9306-2fa1d87051d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-abae-72bf-9306-2fa1d87051d1",
        "storage_key": "property/6767906449167588/01a0101d-abae-72bf-9306-2fa1d87051d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/7095/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14205240733217953946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "38.91248",
      "poi_longitude": "-94.75602",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-829-1728",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73c8-711f-9ca1-113d9a7c1890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73c8-711f-9ca1-113d9a7c1890",
        "storage_key": "property/6767906449167588/019fc924-73c8-711f-9ca1-113d9a7c1890.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJM8nyKBOVwIcRmphdLC8nI8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c932aa8c-98d9-46ac-800b-0d74c4588863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Johnny's Italian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "12080 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Steaks, Italian dishes & cocktails served in upscale, supper club-like environs with a sleek bar.",
      "poi_long_description": "Steaks, Italian dishes & cocktails served in upscale, supper club-like environs with a sleek bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-ac9e-7318-9264-3b5dfdc83349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-ac9e-7318-9264-3b5dfdc83349",
        "storage_key": "property/6767906449167588/019ff6c8-ac9e-7318-9264-3b5dfdc83349.webp",
        "width": 1280,
        "height": 1270
      },
      "poi_business_url": "http://johnnysitaliansteakhouse.com/olathe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5805194116483520704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnnys-italian-steakhouse",
      "poi_latitude": "38.910645",
      "poi_longitude": "-94.769716",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-815-2323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDxhq-J-VwIcRwBgwrUoxkFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6018a893-9e9e-4dab-ab23-78a93c2bddee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Red Crow Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1062 W Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-a9a0-73bb-af86-d60371b3eeb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-a9a0-73bb-af86-d60371b3eeb2",
        "storage_key": "property/6767906449167588/01a0101d-a9a0-73bb-af86-d60371b3eeb2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://redcrowbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041481511854135563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-crow-brewing-company",
      "poi_latitude": "38.8843459",
      "poi_longitude": "-94.83278450000002",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-440-9852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUGfXUm6wIcRC9lT_YfLeX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_1f7922f2-6eaa-40ca-b54e-f17708c34da2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "everbowl",
      "poi_type": "Restaurants",
      "poi_address": "14937 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Trendy chain serving healthy açaí bowls and smoothies made with organic ingredients.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-a5ba-7789-806d-8e64a2ae7b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-a5ba-7789-806d-8e64a2ae7b42",
        "storage_key": "property/6767906449167588/01a0101d-a5ba-7789-806d-8e64a2ae7b42.webp",
        "width": 875,
        "height": 1280
      },
      "poi_business_url": "https://www.everbowl.com/acai-bowl-locations/olathe-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=918517658166005264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "everbowl",
      "poi_latitude": "38.911567",
      "poi_longitude": "-94.75909",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-839-3709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfaa6aSWVwIcREI7ojvE6vww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "acai_shop"
    },
    {
      "id": "custom_3425b4c9-c31a-4730-b539-f8a4eba12af8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "15100 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-a8a7-72b8-8a51-fc1e1e146b33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-a8a7-72b8-8a51-fc1e1e146b33",
        "storage_key": "property/6767906449167588/01a0101d-a8a7-72b8-8a51-fc1e1e146b33.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.chipotle.com/ks/olathe/15100-w-119th-st?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=49",
      "poi_directions_map_url": "https://maps.google.com/?cid=7273872095339814997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "38.9133669",
      "poi_longitude": "-94.7615498",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-393-3319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJawN1IQ2VwIcRVSBb0CH88WQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0e3ad654-8d02-48ee-aa1c-e0cb84b10b3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Noodles and Company",
      "poi_type": "Restaurants",
      "poi_address": "15208 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_long_description": "Counter-serve chain offering international noodle & pasta dishes from mac 'n' cheese to Pad Thai.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-266d-77cb-a9e3-8e534431d5e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-266d-77cb-a9e3-8e534431d5e4",
        "storage_key": "property/6767906449167588/019fc924-266d-77cb-a9e3-8e534431d5e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.noodles.com/ks/olathe/15208-west-119th-street?utm_campaign=soci&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=10684099060622351891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "noodles-and-company",
      "poi_latitude": "38.9133592",
      "poi_longitude": "-94.7628037",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-829-4848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTsNwAyVwIcRE956JX2LRZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_e75f82a7-e9ee-4017-9b17-dbe2b4ee5f3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "15090 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-2715-725f-b149-50558a51cfe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-2715-725f-b149-50558a51cfe8",
        "storage_key": "property/6767906449167588/019fc924-2715-725f-b149-50558a51cfe8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ks/olathe/olathe-point/1535?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:olathe-ks-1535_pl:locurl_rd:1405",
      "poi_directions_map_url": "https://maps.google.com/?cid=5748333876812350428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "38.913335",
      "poi_longitude": "-94.76028",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-768-4372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2oaFA2VwIcR3IO-eTQvxk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_836a96ad-fe3b-4a9f-b236-67a1a5736316",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "14965 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-a9b3-75ac-a0cf-ac8cf47fc643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-a9b3-75ac-a0cf-ac8cf47fc643",
        "storage_key": "property/6767906449167588/01a0101d-a9b3-75ac-a0cf-ac8cf47fc643.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://restaurants.fiveguys.com/14965-west-119th-street",
      "poi_directions_map_url": "https://maps.google.com/?cid=18013038582670899498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "38.9110616",
      "poi_longitude": "-94.7592544",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-780-4987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeQQRA2VwIcRKjmBXScr-_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_96af7856-7fa9-459b-95f8-b26f8d42e7c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "15108 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-ac59-7692-b3f1-6eabfd19304e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-ac59-7692-b3f1-6eabfd19304e",
        "storage_key": "property/6767906449167588/019ff6c8-ac59-7692-b3f1-6eabfd19304e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ks/olathe/15108-west-119th-street?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202366&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=8397242188881082417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "38.913374",
      "poi_longitude": "-94.761623",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-782-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73c8-711f-9ca1-113d9a7c1890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73c8-711f-9ca1-113d9a7c1890",
        "storage_key": "property/6767906449167588/019fc924-73c8-711f-9ca1-113d9a7c1890.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJW3kzPA2VwIcRMTguwUf_iHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_8ffd01df-2bc5-41ef-a70e-8d7ddcd13378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Ginger Sue's",
      "poi_type": "Restaurants",
      "poi_address": "14178 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Local chain of casual eateries, serving eggs & griddle breakfasts, plus comfort food at lunch.",
      "poi_long_description": "Local chain of casual eateries, serving eggs & griddle breakfasts, plus comfort food at lunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-a89a-76af-b3d9-a9313aa2613f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-a89a-76af-b3d9-a9313aa2613f",
        "storage_key": "property/6767906449167588/01a0101d-a89a-76af-b3d9-a9313aa2613f.webp",
        "width": 765,
        "height": 1020
      },
      "poi_business_url": "http://gingersues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=699691680475604441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ginger-sues",
      "poi_latitude": "38.9134546",
      "poi_longitude": "-94.7502602",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-998-9376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSZuURRWVwIcR2WULU-DNtQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_aa1678a4-b17e-4fff-a234-5a59c6a8533a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Freddy's Frozen Custard & Steakburgers",
      "poi_type": "Restaurants",
      "poi_address": "19020 W 151st Terrace, Olathe, KS 66062, USA",
      "poi_short_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_long_description": "Vintage-style chain for steakburgers, hot dogs & other fast-food staples, plus frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-ace4-777c-b561-209909ef85f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-ace4-777c-b561-209909ef85f4",
        "storage_key": "property/6767906449167588/01a0101d-ace4-777c-b561-209909ef85f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.freddys.com/location/olathe-too?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4312477065288903181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freddys-frozen-custard--steakburgers",
      "poi_latitude": "38.8543255",
      "poi_longitude": "-94.8055674",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-782-0503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO00MY3m-wIcRDWqQ2gr_2Ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_f9f49cc3-fc40-4820-9db3-f34dd71802f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "12101 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-aaf5-76bf-ac4e-c050f55bbe5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-aaf5-76bf-ac4e-c050f55bbe5e",
        "storage_key": "property/6767906449167588/01a0101d-aaf5-76bf-ac4e-c050f55bbe5e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/locations/states/ks/olathe/243",
      "poi_directions_map_url": "https://maps.google.com/?cid=16847049468812736311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "38.909173",
      "poi_longitude": "-94.7733774",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-780-9108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwG7PZ-VwIcRNzcEfju-zOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_84cf74ef-a6a5-4e13-8f86-32ed94da6d33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Old Chicago Pizza + Taproom",
      "poi_type": "Restaurants",
      "poi_address": "11969 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Family-friendly chain restaurant featuring Italian entrees along with a wide beer selection.",
      "poi_long_description": "Family-friendly chain restaurant featuring Italian entrees along with a wide beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-270d-779e-91ad-dd3c4404ef56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-270d-779e-91ad-dd3c4404ef56",
        "storage_key": "property/6767906449167588/019fc924-270d-779e-91ad-dd3c4404ef56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oldchicago.com/locations/us/ks/olathe/11969-s-strang-line-road/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5246500584700990853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-chicago-pizza--taproom",
      "poi_latitude": "38.9092105",
      "poi_longitude": "-94.767239",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-764-9850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFYhQD3WVwIcRhVX7EHxQz0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5e19ffaa-77f4-490c-b45d-032f48856a6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "14615 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-d8b1-70e5-95ec-e63cab719ce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-d8b1-70e5-95ec-e63cab719ce2",
        "storage_key": "property/6767906449167588/019fc920-d8b1-70e5-95ec-e63cab719ce2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/olathe?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1867931902899405421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.9114088",
      "poi_longitude": "-94.7563777",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-764-5656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cf272f4b359c",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMa7zJm2VwIcRbULwQCs67Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ab0f7782-7616-4723-b2a3-98fa59f98934",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "18101 W 119th St, Olathe, KS 66061, USA",
      "poi_short_description": "Neighborhood grocery store chain with prepared foods, a deli, and a pharmacy, plus online ordering and pickup.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-359b-7694-9904-fd7be49fdc98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-359b-7694-9904-fd7be49fdc98",
        "storage_key": "property/6767906449167588/019fc924-359b-7694-9904-fd7be49fdc98.webp",
        "width": 1086,
        "height": 764
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=501&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12797416529656855856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.9110474",
      "poi_longitude": "-94.7951339",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-393-4150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cf272f4b359c",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxAxH8KVwIcRML3otIeOmbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0987b8c6-ce0b-4b1b-af56-c6bd5df83a80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "15290 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-3520-73bb-915c-110b406cd17f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-3520-73bb-915c-110b406cd17f",
        "storage_key": "property/6767906449167588/019fc924-3520-73bb-915c-110b406cd17f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/olathe/15290-w-119th-street/f345",
      "poi_directions_map_url": "https://maps.google.com/?cid=2191206293638967824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.915347",
      "poi_longitude": "-94.763142",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cf272f4b359c",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrfyVMyy-wIcREHLzuYO6aB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_601836a2-0ade-448c-a2b9-7710453af956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "13600 S Alden St, Olathe, KS 66062, USA",
      "poi_short_description": "Grocery and home goods retailer selling household essentials, plus toys, clothing, electronics and furniture.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-6025-700b-81a5-86daea673639.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-6025-700b-81a5-86daea673639",
        "storage_key": "property/6767906449167588/019fc924-6025-700b-81a5-86daea673639.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/577-olathe-ks/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8847812053339146437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "38.8813311",
      "poi_longitude": "-94.7580085",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-829-4404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-00fe-71da-bbd2-80397e160bb3",
        "storage_key": "property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKfgVptq_wIcRxQizTi--yXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_da5b8e1f-53ea-41d0-b311-1309cabd4e0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Ball’s Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "15970 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Chain store offering grocery items – plus a bakery, a deli, a pharmacy, and prepared foods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-ae77-72d1-805a-5879360de706.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-ae77-72d1-805a-5879360de706",
        "storage_key": "property/6767906449167588/01a0101d-ae77-72d1-805a-5879360de706.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=67",
      "poi_directions_map_url": "https://maps.google.com/?cid=18113692941289000892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "balls-price-chopper",
      "poi_latitude": "38.8391901",
      "poi_longitude": "-94.7817974",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-393-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cf272f4b359c",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cf272f4b359c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRND-O--wIcRvA8IeMLDYPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0cb3ad34-b827-4f60-b07a-96f42ccff1bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "15345 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-3b9d-70c9-9988-2c4c83f07b3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-3b9d-70c9-9988-2c4c83f07b3a",
        "storage_key": "property/6767906449167588/019fc924-3b9d-70c9-9988-2c4c83f07b3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/olathe-ks-pharmacies/15345-w-119th-st-olathe-ks-66062/storeid=16883?WT.mc_id=LS_GOOGLE_RX_16883",
      "poi_directions_map_url": "https://maps.google.com/?cid=1680697890390255796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.9099463",
      "poi_longitude": "-94.7643047",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-393-4420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73c6-72f9-9191-121c946c1477.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73c6-72f9-9191-121c946c1477",
        "storage_key": "property/6767906449167588/019fc924-73c6-72f9-9191-121c946c1477.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaw-onSVwIcRtKh1m9MJUxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_04318021-a7ef-4003-9937-087ed7781b00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "13901 S Mur-Len Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-aee9-74db-81ac-b1b9bc9020af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-aee9-74db-81ac-b1b9bc9020af",
        "storage_key": "property/6767906449167588/01a0101d-aee9-74db-81ac-b1b9bc9020af.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/ks/olathe/13901-s-murlen-road-30176?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14184816038637388486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "38.87530479999999",
      "poi_longitude": "-94.7790294",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-782-4816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-cae6-71ee-9dfd-858740fefea9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101d-cae6-71ee-9dfd-858740fefea9",
        "storage_key": "property/6767906449167588/01a0101d-cae6-71ee-9dfd-858740fefea9.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJJc-fpTC-wIcRxsI-YwiX2sQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_0cebc90e-c085-47bb-9dac-5b23e1dc06f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "14904 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-b5b1-75ea-a000-c8203f488115.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-b5b1-75ea-a000-c8203f488115",
        "storage_key": "property/6767906449167588/019ff6c8-b5b1-75ea-a000-c8203f488115.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ks/olathe/14904-w-119th-st?utm_source=gmb&utm_medium=yext&y_source=1_MjA1Mzk5MjQwOC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=31032175473624861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.913308",
      "poi_longitude": "-94.7589232",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-397-2174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-ff7a-77ee-89da-0dbb953483b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c8-ff7a-77ee-89da-0dbb953483b4",
        "storage_key": "property/6767906449167588/019ff6c8-ff7a-77ee-89da-0dbb953483b4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJP9lQtDiVwIcRHYe2Y5k_bgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_f2a9eb1b-bf73-4411-9713-8e2a6dcbd4ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "15280 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-af2b-7618-b067-0e70ad1b6217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-af2b-7618-b067-0e70ad1b6217",
        "storage_key": "property/6767906449167588/01a0101d-af2b-7618-b067-0e70ad1b6217.webp",
        "width": 1024,
        "height": 765
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ks/olathe/117/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=13166168637736225110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dicks-sporting-goods",
      "poi_latitude": "38.9150664",
      "poi_longitude": "-94.7625251",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-254-9196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-00fe-71da-bbd2-80397e160bb3",
        "storage_key": "property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz7rUK5OVwIcRVgkoYZ6gt7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_62f8f7bb-2595-492a-945e-4f640fc3d7c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "15350 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b00d-7349-8d7b-8f78e9c2a701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b00d-7349-8d7b-8f78e9c2a701",
        "storage_key": "property/6767906449167588/01a0101d-b00d-7349-8d7b-8f78e9c2a701.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11953065326640001407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "38.914446",
      "poi_longitude": "-94.7639496",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-390-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-00fe-71da-bbd2-80397e160bb3",
        "storage_key": "property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtQqbhguVwIcRf3Fqo5XR4aU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_bec20611-791e-47d3-826a-efebb1d6ab52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Walnut Grove Elementary School",
      "poi_type": "Education",
      "poi_address": "11800 South Pflumm Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.olatheschools.org/walnutgrove/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11890214342694769779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walnut-grove-elementary-school",
      "poi_latitude": "38.9147622",
      "poi_longitude": "-94.7450276",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-780-7710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZSXY_T6VwIcRc5STl_KGAqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_654d215a-5819-4520-bb5b-4ceff9b64bfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Regency Place Elementary School",
      "poi_type": "Education",
      "poi_address": "13250 S Greenwood St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-3e09-734c-8e2d-2d7cece3802c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-3e09-734c-8e2d-2d7cece3802c",
        "storage_key": "property/6767906449167588/019fc924-3e09-734c-8e2d-2d7cece3802c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheschools.org/regencyplace/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12860185387975329175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-place-elementary-school",
      "poi_latitude": "38.8881055",
      "poi_longitude": "-94.7510144",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-780-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfQT9U96_wIcRl0XwY3mOeLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ab431eca-ba92-42a9-9c3d-a46470c62b50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Heatherstone Elementary School",
      "poi_type": "Education",
      "poi_address": "13745 W 123rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b104-7370-82cd-dfd6145be788.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b104-7370-82cd-dfd6145be788",
        "storage_key": "property/6767906449167588/01a0101d-b104-7370-82cd-dfd6145be788.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.olatheschools.org/heatherstone/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3018258241740094687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heatherstone-elementary-school",
      "poi_latitude": "38.9050502",
      "poi_longitude": "-94.7457069",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-780-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzVV8VUKVwIcR3zxQI-EB4yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_594dfea5-0a07-4e9e-aa24-f55fe0639898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Pioneer Trail Middle School",
      "poi_type": "Education",
      "poi_address": "15100 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/pioneertrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2058636432383380672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-trail-middle-school",
      "poi_latitude": "38.8992082",
      "poi_longitude": "-94.7643025",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6fYTI3qVwIcRwIzjme2-kRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2389f9a9-04d3-493f-ae76-0fde41953ef6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Olathe East High School",
      "poi_type": "Education",
      "poi_address": "14545 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-40df-7418-a37f-597fc1a2d3e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-40df-7418-a37f-597fc1a2d3e4",
        "storage_key": "property/6767906449167588/019fc924-40df-7418-a37f-597fc1a2d3e4.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "http://www.olatheschools.org/east/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4226639083448974343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-east-high-school",
      "poi_latitude": "38.8956297",
      "poi_longitude": "-94.7538396",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg4KXUWGVwIcRBzzCStoJqDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1b2470f6-58b0-4458-81e5-a59420479ce0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Kiddie Academy of Olathe",
      "poi_type": "Education",
      "poi_address": "1585 S Mahaffie Cir, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b5d2-753f-92c5-d40e079e5c9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b5d2-753f-92c5-d40e079e5c9b",
        "storage_key": "property/6767906449167588/01a0101d-b5d2-753f-92c5-d40e079e5c9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kiddieacademy.com/academies/olathe/",
      "poi_directions_map_url": "https://maps.google.com/?cid=440037305803804362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiddie-academy-of-olathe",
      "poi_latitude": "38.8563946",
      "poi_longitude": "-94.8061023",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-732-7773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbUt8uZ6_wIcRyg5bJJlTGwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f425cb63-82d4-4db5-9261-09911650a6fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "MidAmerica Nazarene University",
      "poi_type": "Education",
      "poi_address": "2030 E College Way, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-de82-77fb-8175-54330d6d993f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-de82-77fb-8175-54330d6d993f",
        "storage_key": "property/6767906449167588/019fc920-de82-77fb-8175-54330d6d993f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mnu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7871762714009878451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midamerica-nazarene-university",
      "poi_latitude": "38.8760668",
      "poi_longitude": "-94.7823676",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-782-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP7fBszu-wIcRsz-5ZHsePm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bef14572-30ba-4573-bfb2-fa8bd1fe3460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Prince of Peace Catholic School",
      "poi_type": "Education",
      "poi_address": "16000 W 143rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-3fc3-73c8-adf8-5309cbd207f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-3fc3-73c8-adf8-5309cbd207f2",
        "storage_key": "property/6767906449167588/019fc924-3fc3-73c8-adf8-5309cbd207f2.webp",
        "width": 816,
        "height": 459
      },
      "poi_business_url": "https://www.popolathe.org/school",
      "poi_directions_map_url": "https://maps.google.com/?cid=12179312179108343644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prince-of-peace-catholic-school",
      "poi_latitude": "38.8695147",
      "poi_longitude": "-94.7717438",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-764-0650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_wh_cTW-wIcRXG9X7OWbBak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_506ab15b-cb28-49f9-9ec2-256b3c0f161d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Christ Lutheran School and Early Education Center",
      "poi_type": "Education",
      "poi_address": "11720 Nieman Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b2c3-714a-8c94-34b1a061c4e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b2c3-714a-8c94-34b1a061c4e1",
        "storage_key": "property/6767906449167588/01a0101d-b2c3-714a-8c94-34b1a061c4e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clsop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13821636895518771355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christ-lutheran-school-and-early-education-center",
      "poi_latitude": "38.91491200000001",
      "poi_longitude": "-94.7152594",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-754-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_9_itsfqwIcRm0jUu4ZR0L8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_34cc1b36-2388-46a5-b8b7-ca8e9b983069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-d37d-759a-b907-63b0b89f028a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-d37d-759a-b907-63b0b89f028a",
        "storage_key": "property/6767906449167588/019fc920-d37d-759a-b907-63b0b89f028a.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f93e7563-9038-4d60-8e2f-0933749adf10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "AMC Studio 28",
      "poi_type": "Entertainment",
      "poi_address": "12075 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Movie theater and dine-in eatery offering the latest releases, as well as a bar and snack counter.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-42f2-737b-94c4-9648222aeb96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-42f2-737b-94c4-9648222aeb96",
        "storage_key": "property/6767906449167588/019fc924-42f2-737b-94c4-9648222aeb96.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-studio-28?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16780991066006934845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-studio-28",
      "poi_latitude": "38.907307",
      "poi_longitude": "-94.7671361",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-393-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73ba-7112-b5ca-e12dbe44e90e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73ba-7112-b5ca-e12dbe44e90e",
        "storage_key": "property/6767906449167588/019fc924-73ba-7112-b5ca-e12dbe44e90e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3tZuHWVwIcRPdVYDHcO4ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b02203e4-eb78-4b57-b744-70d4fca00c90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Sylas & Maddy's Homemade Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "11925 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Charming counter-serve providing classic & original flavors of ice cream & toppings.",
      "poi_long_description": "Charming counter-serve providing classic & original flavors of ice cream & toppings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b561-7461-bf78-b9b999fe19f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b561-7461-bf78-b9b999fe19f3",
        "storage_key": "property/6767906449167588/01a0101d-b561-7461-bf78-b9b999fe19f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sylasandmaddysicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9684396542657520806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sylas--maddys-homemade-ice-cream",
      "poi_latitude": "38.9101967",
      "poi_longitude": "-94.7660426",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-393-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-00fe-71da-bbd2-80397e160bb3",
        "storage_key": "property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJByohc3WVwIcRpmQfbVjjZYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_a955083e-36a3-4fc9-9197-ebd6f3beecbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Olathe Civic Theatre Association",
      "poi_type": "Entertainment",
      "poi_address": "500 E Loula St, Olathe, KS 66061, USA",
      "poi_short_description": "Theater and event-space venue, staging a variety of musical and comedic productions, from classics to current shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-46c4-730f-a424-5b8b34f7d185.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-46c4-730f-a424-5b8b34f7d185",
        "storage_key": "property/6767906449167588/019fc924-46c4-730f-a424-5b8b34f7d185.webp",
        "width": 604,
        "height": 402
      },
      "poi_business_url": "http://www.olathetheatre.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1677147266849540730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-civic-theatre-association",
      "poi_latitude": "38.88076",
      "poi_longitude": "-94.81113",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-782-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO9uSeP29wIcReoqVpI1sRhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9d2f6cf1-b1c2-4bfe-b2d4-0747c3e8fdab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Main Event Olathe",
      "poi_type": "Restaurants",
      "poi_address": "11950 N Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Casual entertainment venue featuring laser tag and a rope course, plus bowling lanes and arcade-style video games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-43ff-71c0-804a-37ca1953e242.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-43ff-71c0-804a-37ca1953e242",
        "storage_key": "property/6767906449167588/019fc924-43ff-71c0-804a-37ca1953e242.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.mainevent.com/locations/kansas/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=14851719059725861874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-olathe",
      "poi_latitude": "38.911748",
      "poi_longitude": "-94.7758366",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-768-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOURoFKKVwIcR8sPbCsznG84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c7b30497-fbef-468b-b57e-3e8d8c70c581",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-c9a0-758e-8cd3-371da8577724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-c9a0-758e-8cd3-371da8577724",
        "storage_key": "property/6767906449167588/019ff6c8-c9a0-758e-8cd3-371da8577724.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dd8b054b-37e3-4ca5-85ba-6f3e48b8e3e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-e00d-776e-858a-5a7ec98a2098.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-e00d-776e-858a-5a7ec98a2098",
        "storage_key": "property/6767906449167588/019fc920-e00d-776e-858a-5a7ec98a2098.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0140-75ec-a2c5-ed072c812ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0140-75ec-a2c5-ed072c812ca3",
        "storage_key": "property/6767906449167588/019fc921-0140-75ec-a2c5-ed072c812ca3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2fb9c550-d440-4261-a38b-84d336a31890",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-dd50-722d-b1f7-326f604827fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-dd50-722d-b1f7-326f604827fb",
        "storage_key": "property/6767906449167588/019fc920-dd50-722d-b1f7-326f604827fb.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6393b46b-44dc-4b9d-a4c4-81e1a52171bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "10975 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "State-of-the-art wind tunnels are used for indoor skydiving at this family-friendly entertainment center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b2d9-7063-8aeb-af2e42a28a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b2d9-7063-8aeb-af2e42a28a2b",
        "storage_key": "property/6767906449167588/01a0101d-b2d9-7063-8aeb-af2e42a28a2b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/kansas-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2133132905847574967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---kansas-city",
      "poi_latitude": "38.93024",
      "poi_longitude": "-94.666288",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-305-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wSq70nqwIcRt9G9dxNpmh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_b22717c0-3626-4ec3-a189-563b39450aa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Dave & Buster's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6811 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b5c4-74ee-86d3-5a31124b4ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b5c4-74ee-86d3-5a31124b4ff4",
        "storage_key": "property/6767906449167588/01a0101d-b5c4-74ee-86d3-5a31124b4ff4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2445764442989428663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-overland-park",
      "poi_latitude": "38.88149050000001",
      "poi_longitude": "-94.6652889",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-249-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0101-7645-9cba-cb5c3a4298b4",
        "storage_key": "property/6767906449167588/019fc921-0101-7645-9cba-cb5c3a4298b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVr1MujBwIcRt3-qfM0Z8SE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ef230351-9abd-4660-bbb1-623ebf3ca317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Tall Trellis Brew Co.",
      "poi_type": "Restaurants",
      "poi_address": "25600 W Valley Pkwy, Olathe, KS 66061, USA",
      "poi_short_description": "Brewpub featuring outdoor seating for casual eats and housemade and local brews.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b402-72e2-9629-28367c728a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b402-72e2-9629-28367c728a79",
        "storage_key": "property/6767906449167588/01a0101d-b402-72e2-9629-28367c728a79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talltrellis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9598319035616604153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tall-trellis-brew-co",
      "poi_latitude": "38.9450675",
      "poi_longitude": "-94.8846037",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QZJJ3iXwIcR-S_MDk8UNIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_c7efb90c-546e-4d0c-a8cc-5373f0e87795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Olathe Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "20333 W 151st St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-4b09-7152-91d6-3f1bd322de95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-4b09-7152-91d6-3f1bd322de95",
        "storage_key": "property/6767906449167588/019fc924-4b09-7152-91d6-3f1bd322de95.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/olathe-hospital?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=16276948923291160757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-hospital",
      "poi_latitude": "38.85260299999999",
      "poi_longitude": "-94.822969",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-445-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0144-74dd-ad66-63168a00de70.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0144-74dd-ad66-63168a00de70",
        "storage_key": "property/6767906449167588/019fc921-0144-74dd-ad66-63168a00de70.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQclTbs69wIcRtVDyh85W4-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_b9dbe194-c56e-4946-a542-1b74b3378f68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Urgent Care, Arbor Creek Medical Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "16538 W 159th Terrace, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olathehealth.org/locations/olathe-health-urgent-care---arbor-creek?name=Olathe+Health+Urgent+Care+-+Arbor+Creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=7098895033309385864&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-care-arbor-creek-medical-pavilion",
      "poi_latitude": "38.8396123",
      "poi_longitude": "-94.7783135",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-445-8660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB2kqPkW_wIcRiNQw1mtXhGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_20cf854b-b2d5-4518-a8cc-1072bd393435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Urgent Care, Blackfoot Medical Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "15435 W 134th Pl #101, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-4c3e-73d4-b754-6581a037e199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-4c3e-73d4-b754-6581a037e199",
        "storage_key": "property/6767906449167588/019fc924-4c3e-73d4-b754-6581a037e199.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "https://www.kansashealthsystem.com/locations/urgent-care-blackfoot-medical-pavilion?utm_source=google_business_profile&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11950359307099950029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-care-blackfoot-medical-pavilion",
      "poi_latitude": "38.8844201",
      "poi_longitude": "-94.7646412",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-445-7520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDaiHkdO_wIcRzcv5XXk02KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_772dea49-b01f-444d-84e2-b5515b1c0f95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "13450 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-cc54-74b2-9dca-2fa475cfbcff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-cc54-74b2-9dca-2fa475cfbcff",
        "storage_key": "property/6767906449167588/019ff6c8-cc54-74b2-9dca-2fa475cfbcff.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-13450+s+blackbob+rd-olathe-ks-66062/id=4665",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796038198735279990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8843227",
      "poi_longitude": "-94.7616559",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-829-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3StTdC_wIcRdhfmTHQ6-PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_7aaf57a9-881e-4463-88ba-3fe9a11ae5f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "The Foundation Olathe 24hr Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "15274 W 119th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-cd8e-74bc-a9de-0f2d510ccc1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-cd8e-74bc-a9de-0f2d510ccc1e",
        "storage_key": "property/6767906449167588/019ff6c8-cd8e-74bc-a9de-0f2d510ccc1e.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.tfgyms.com/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=13187871783481882742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-foundation-olathe-24hr-gym",
      "poi_latitude": "38.915342",
      "poi_longitude": "-94.7616886",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-839-8651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvS1YQN2VwIcRdrjVxYO7BLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d2212041-5337-488c-8894-1b826de6c7ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Olathe Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "21400 W 153rd St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-4f6e-72db-8fab-76e85d275c36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-4f6e-72db-8fab-76e85d275c36",
        "storage_key": "property/6767906449167588/019fc924-4f6e-72db-8fab-76e85d275c36.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://kansascityymca.org/locations/olathe",
      "poi_directions_map_url": "https://maps.google.com/?cid=3427068300167585099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-family-ymca",
      "poi_latitude": "38.8503418",
      "poi_longitude": "-94.8330142",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-393-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5ZPjxrW9wIcRS519LHZkjy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_cda52e12-29ab-46b0-9029-5aee7980e15e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Paradiso Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 S Ridgeview Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-b46f-743b-a4aa-32148eba5cd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-b46f-743b-a4aa-32148eba5cd6",
        "storage_key": "property/6767906449167588/01a0101d-b46f-743b-a4aa-32148eba5cd6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.paradisopilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15087954959420912987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paradiso-pilates",
      "poi_latitude": "38.8527136",
      "poi_longitude": "-94.7982603",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-355-6564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpzqpwxa_wIcRW3VgnxgvY9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e624986-0173-416d-b488-07d057672e3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Sumits Hot Yoga KC",
      "poi_type": "Health and Wellness",
      "poi_address": "15153 W 119th St #E09, Olathe, KS 66062, USA",
      "poi_short_description": "Hot yoga studio offering Bikram and Vinyasa classes, plus clothing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-5ef2-7549-a672-5503702b3452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-5ef2-7549-a672-5503702b3452",
        "storage_key": "property/6767906449167588/019fc924-5ef2-7549-a672-5503702b3452.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://sumitskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11250434456908358923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sumits-hot-yoga-kc",
      "poi_latitude": "38.9121004",
      "poi_longitude": "-94.7625425",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-601-2410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcReOGHOVwIcRC2XW_IeSIZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_39294966-7670-44d9-b0c1-e97d0f1d803c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Santa Marta Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11540-11598 S Greenwood St, Olathe, KS 66062, USA",
      "poi_short_description": "Playground along with picnic tables and a walking trail are featured at this landscaped space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-52e0-77e8-a44e-0b7ca0cb5715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-52e0-77e8-a44e-0b7ca0cb5715",
        "storage_key": "property/6767906449167588/019fc924-52e0-77e8-a44e-0b7ca0cb5715.webp",
        "width": 1255,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15301564658025647578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santa-marta-park",
      "poi_latitude": "38.9196234",
      "poi_longitude": "-94.7508276",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzUfCSxaVwIcR2k1KPfwTWtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cb3fcc75-931f-4f6e-91b4-056220d1b627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Eastbrooke Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-5217-71f8-bf95-b8d833ed1b37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-5217-71f8-bf95-b8d833ed1b37",
        "storage_key": "property/6767906449167588/019fc924-5217-71f8-bf95-b8d833ed1b37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/parks/eastbrooke-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14050912344560607742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastbrooke-park",
      "poi_latitude": "38.8914776",
      "poi_longitude": "-94.7499075",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Wk5ImCVwIcR_qGvG1Xe_sI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_03b259af-4547-44a0-81e8-43e08e03b634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Quailwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14092 S Greenwood St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-bcea-7632-b8ff-8af3b1f0bca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-bcea-7632-b8ff-8af3b1f0bca4",
        "storage_key": "property/6767906449167588/01a0101d-bcea-7632-b8ff-8af3b1f0bca4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12280956497587172029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quailwood-park",
      "poi_latitude": "38.8746012",
      "poi_longitude": "-94.7502343",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJheaXm7u_wIcRvXK1BN64bqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_56c0d64d-c01a-44d6-9108-7b95d73a8e9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Lake Olathe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 S Lakeshore Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Park featuring a beach, an obstacle course, a waterfall and cliffs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-592c-7695-9121-b665238b8fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-592c-7695-9121-b665238b8fd2",
        "storage_key": "property/6767906449167588/019fc924-592c-7695-9121-b665238b8fd2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/lake-olathe-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6997584864379487297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-olathe-park",
      "poi_latitude": "38.8735242",
      "poi_longitude": "-94.8731186",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-971-8973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYZtehEK9wIcRQUT9_ltqHGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b0640cbf-d4bf-4a4c-909b-eca269c716fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Cedar Niles Park Clare Road Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12650 S Clare Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Vast park with rugged trails, a paved path and a looped option for hiking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-bed7-76e8-a0bb-be8b6fa343ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-bed7-76e8-a0bb-be8b6fa343ba",
        "storage_key": "property/6767906449167588/01a0101d-bed7-76e8-a0bb-be8b6fa343ba.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.jcprd.com/990/Cedar-Niles-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3633081766504754701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-niles-park-clare-road-trailhead",
      "poi_latitude": "38.8996513",
      "poi_longitude": "-94.8719792",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8M35heXwIcRDe52JJ5MazI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5c2ce666-30d1-4798-9c3d-90afe9d57162",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Cedar Lake",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15500 S Lone Elm Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Small lake featuring a playground, picnic facilities, and fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-bf9a-712e-9045-2cc0440fc616.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-bf9a-712e-9045-2cc0440fc616",
        "storage_key": "property/6767906449167588/01a0101d-bf9a-712e-9045-2cc0440fc616.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/cedar-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8993153085847633081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-lake",
      "poi_latitude": "38.8457194",
      "poi_longitude": "-94.8432857",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5S-S629wIcRufyndBUZznw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1fdcec58-c945-4321-9b86-fb0ed965eb3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Black Bob Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14500 W 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_long_description": "Recreation complex with athletic fields, a mini-golf course & an outdoor pool with waterslides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-f134-71aa-8c00-e036e13e4fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-f134-71aa-8c00-e036e13e4fda",
        "storage_key": "property/6767906449167588/019fc920-f134-71aa-8c00-e036e13e4fda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/black-bob-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317087441858333318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-bob-park",
      "poi_latitude": "38.8583619",
      "poi_longitude": "-94.7539901",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTqNmKS_wIcRhgoMG4_Nqlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3feb92f6-2bd7-41b6-abcf-961b35095236",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Ernie Miller Park & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "909 North, KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_long_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-4546-729e-84e0-51b63b6b5401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-4546-729e-84e0-51b63b6b5401",
        "storage_key": "property/6767906449167588/019fc924-4546-729e-84e0-51b63b6b5401.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://erniemiller.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5769145388029025309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernie-miller-park--nature-center",
      "poi_latitude": "38.8967913",
      "poi_longitude": "-94.8409835",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-826-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt22HnSWWwIcRHZwNByofEFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_965b90bf-d1c3-4d6b-9b00-ab5a04187319",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Mahaffie Stagecoach Stop-Farm",
      "poi_type": "Entertainment",
      "poi_address": "1200 E Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_long_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-4851-75c9-af3e-a8ebd877de27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-4851-75c9-af3e-a8ebd877de27",
        "storage_key": "property/6767906449167588/019fc924-4851-75c9-af3e-a8ebd877de27.webp",
        "width": 1200,
        "height": 965
      },
      "poi_business_url": "http://www.mahaffie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4906880325698000129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-stagecoach-stop-farm",
      "poi_latitude": "38.8920954",
      "poi_longitude": "-94.7996569",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-971-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0140-75ec-a2c5-ed072c812ca3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0140-75ec-a2c5-ed072c812ca3",
        "storage_key": "property/6767906449167588/019fc921-0140-75ec-a2c5-ed072c812ca3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5f59bfeVwIcRARWVkKi9GEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bf7ad17e-15ef-4116-9393-0f55f8292ae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Prairie Center Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "555 N Olathe View Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Community park covering 86 acres with a fishing pond, trail, soccer & baseball fields & disc golf.",
      "poi_long_description": "Community park covering 86 acres with a fishing pond, trail, soccer & baseball fields & disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-da60-761d-ac86-5ef0a6541158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-da60-761d-ac86-5ef0a6541158",
        "storage_key": "property/6767906449167588/019ff6c8-da60-761d-ac86-5ef0a6541158.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/parks/prairie-center-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1548584147364877856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-center-park",
      "poi_latitude": "38.8907907",
      "poi_longitude": "-94.8462045",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013d-710a-a7b0-07453d241ae2",
        "storage_key": "property/6767906449167588/019fc921-013d-710a-a7b0-07453d241ae2.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7aiBfCmWwIcRIBZ8yBOtfRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d9b02f20-28c8-44e3-b3d0-46f253785100",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-db21-75f2-a542-f720131599e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-db21-75f2-a542-f720131599e8",
        "storage_key": "property/6767906449167588/019ff6c8-db21-75f2-a542-f720131599e8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73d6-7049-84fe-fa3c804c73ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73d6-7049-84fe-fa3c804c73ee",
        "storage_key": "property/6767906449167588/019fc924-73d6-7049-84fe-fa3c804c73ee.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_4dc51382-1e8e-4ecc-a7be-abde63867cae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-7408-766f-8fd3-39a33e5e64a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-7408-766f-8fd3-39a33e5e64a7",
        "storage_key": "property/6767906449167588/019fc924-7408-766f-8fd3-39a33e5e64a7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_d2520965-ba0c-4ae2-bc12-6d0a40f0d686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "11.6",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-7408-766f-8fd3-39a33e5e64a7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-7408-766f-8fd3-39a33e5e64a7",
        "storage_key": "property/6767906449167588/019fc924-7408-766f-8fd3-39a33e5e64a7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_d0719ed1-a564-4120-b210-90af7734d37c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Johnson County Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "1701 W Old 56 Hwy, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-e36b-7284-a1ce-381141439ffc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-e36b-7284-a1ce-381141439ffc",
        "storage_key": "property/6767906449167588/019ff6c8-e36b-7284-a1ce-381141439ffc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/dept/transit/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259441942160797783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-transit",
      "poi_latitude": "38.8639984",
      "poi_longitude": "-94.8448333",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-362-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcRjftqO9wIcRV_CsTkgB3lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d5a42dc8-18d2-4f50-877d-0b244facb031",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-c1e5-7011-933b-2a75b08d87b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-c1e5-7011-933b-2a75b08d87b4",
        "storage_key": "property/6767906449167588/01a0101d-c1e5-7011-933b-2a75b08d87b4.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_74e8ad02-a141-48a4-a0ee-3a57a45d8339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-61cf-705b-9d40-7801ec0d2558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-61cf-705b-9d40-7801ec0d2558",
        "storage_key": "property/6767906449167588/019fc924-61cf-705b-9d40-7801ec0d2558.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "39.3",
      "poi_walking_minutes": "14 hours 35 mins",
      "poi_biking_minutes": "4 hours 7 mins",
      "poi_driving_minutes": "38 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-08be-7176-bb3f-fe7ce6a04404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-08be-7176-bb3f-fe7ce6a04404",
        "storage_key": "property/6767906449167588/019fc921-08be-7176-bb3f-fe7ce6a04404.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_8f6bc4ce-f43e-41d5-872c-b6a4f17c3ee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc920-f4d3-7295-9178-fa0e460a7c03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-f4d3-7295-9178-fa0e460a7c03",
        "storage_key": "property/6767906449167588/019fc920-f4d3-7295-9178-fa0e460a7c03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4a36c122-b186-4f7a-bf60-732ba18bce5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Olathe Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14160 S Black Bob Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-63c4-71e8-99ef-a317e558396b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-63c4-71e8-99ef-a317e558396b",
        "storage_key": "property/6767906449167588/019fc924-63c4-71e8-99ef-a317e558396b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.olatheschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2471559516784985002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-public-schools",
      "poi_latitude": "38.8710187",
      "poi_longitude": "-94.7620475",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-780-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-0102-72c3-a37c-13246905aeb6",
        "storage_key": "property/6767906449167588/019fc921-0102-72c3-a37c-13246905aeb6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAyR-Mci_wIcRqoM0H0m-TCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1549355d-7144-4e02-9882-32f0407e0904",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019ff6c8-ef65-76fe-a43f-79d49841cb00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-ef65-76fe-a43f-79d49841cb00",
        "storage_key": "property/6767906449167588/019ff6c8-ef65-76fe-a43f-79d49841cb00.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73d2-773e-9d94-a62e2351dbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73d2-773e-9d94-a62e2351dbe4",
        "storage_key": "property/6767906449167588/019fc924-73d2-773e-9d94-a62e2351dbe4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_76f4038c-521d-43c7-9b09-d91d503d97f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "City of Olathe City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 E Santa Fe St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-6656-72bc-85c6-36168ff29c88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc924-6656-72bc-85c6-36168ff29c88",
        "storage_key": "property/6767906449167588/019fc924-6656-72bc-85c6-36168ff29c88.webp",
        "width": 1280,
        "height": 813
      },
      "poi_business_url": "http://www.olatheks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9492556933527452182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-olathe-city-hall",
      "poi_latitude": "38.883783",
      "poi_longitude": "-94.8192239",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-971-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73d2-773e-9d94-a62e2351dbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73d2-773e-9d94-a62e2351dbe4",
        "storage_key": "property/6767906449167588/019fc924-73d2-773e-9d94-a62e2351dbe4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeUibmfm9wIcRFjoTwTxWvIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_9347b95f-5eb3-4c6d-8b54-bc15ff2c756d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "FAA Kansas City Air Route Traffic Control Center (ARTCC ZKC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "250 S Rogers Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.faa.gov/about/office_org/headquarters_offices/ato/service_units/air_traffic_services/artcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14145768989397863200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faa-kansas-city-air-route-traffic-control-center-artcc-zkc",
      "poi_latitude": "38.8800671",
      "poi_longitude": "-94.7905515",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-254-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc924-73d2-773e-9d94-a62e2351dbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc924-73d2-773e-9d94-a62e2351dbe4",
        "storage_key": "property/6767906449167588/019fc924-73d2-773e-9d94-a62e2351dbe4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRLUERi-wIcRIMvLx_LdT8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_882092b4-1851-4c2b-8c20-95d743a8e768",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "12051 Bass Pro Dr, Olathe, KS 66061, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-c2be-77df-a43c-4b5c21d3bb92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-c2be-77df-a43c-4b5c21d3bb92",
        "storage_key": "property/6767906449167588/01a0101d-c2be-77df-a43c-4b5c21d3bb92.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.basspro.com/us/ks/olathe/12051-bass-pro-dr.html?y_source=1_MzAxMTUzMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12711594026814670412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "38.9095905",
      "poi_longitude": "-94.7774654",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-254-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-00fe-71da-bbd2-80397e160bb3",
        "storage_key": "property/6767906449167588/019fc921-00fe-71da-bbd2-80397e160bb3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi3EcXZiVwIcRTAZEIWunaLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_1f624820-3c0d-4b11-8677-24ca9cf9d164",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "custom",
      "poi_name": "John Deere Ag Marketing Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10789 S Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101d-c435-74a4-86bc-73b51963a2c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101d-c435-74a4-86bc-73b51963a2c5",
        "storage_key": "property/6767906449167588/01a0101d-c435-74a4-86bc-73b51963a2c5.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2833214193495935070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-deere-ag-marketing-center",
      "poi_latitude": "38.9333322",
      "poi_longitude": "-94.7952825",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-310-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-013f-7244-9b4f-6203eff51216",
        "storage_key": "property/6767906449167588/019fc921-013f-7244-9b4f-6203eff51216.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6uWnjOUwIcRXojrR0yZUSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d838b467f374a90d07556ea9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c6de048831bb68b4b4c86f5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_56429836f0fe2509ab4a645c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_45930ddf4fa946d973552059",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ed3f600214411fa38821ba2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_020a8357354feae134af49ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4482635935c4e5b2e4d9a2da",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "rating": "5",
      "name": "Mark Grigware",
      "text": "Lauren are concierge is a wonderful person.  Always goes above and beyond her job.  Always has a smile and takes time to talk to you and wants to know about our day.  My husband and I look forward to seeing her before exercise when we go.  She a delight 😊",
      "date": "2026-03-22",
      "title": "false"
    },
    {
      "id": "ec_2f69c42304d52348a5e668d8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "rating": "5",
      "name": "Chris Means",
      "text": "Avignon is a great apartment complex to live in. They have great green spaces for walking my dog, and the maintenance team is always quick to fix any issues that come up. The office staff are always helpful, and it is located in a great area. I would definitely recommend living here.",
      "date": "2026-02-21",
      "title": "false"
    },
    {
      "id": "ec_ef6ab3afe61a30369a9d5a44",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "rating": "5",
      "name": "D S",
      "text": "Ronnell is absolutely wonderful very friendly and professional. He makes us feel like we’re never a bother with a maintenance call even if we think it’s something small to report. I appreciate him and the entire staff at Avignon.",
      "date": "2026-02-04",
      "title": "false"
    },
    {
      "id": "ec_8a77246b1ef54a801f65f4ce",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "rating": "5",
      "name": "Griffin Buschjost",
      "text": "Lauren at the front desk is the nicest person ever and the maintenance staff is extremely helpful and responsive! Lauren does a great job setting up fun events each month as well.\n\nThe apartments themselves are high quality, comfortable, and most importantly safe. There is a really feeling of neighborhood with Avignon.",
      "date": "2026-01-18",
      "title": "false"
    },
    {
      "id": "ec_417bddeec743ef29e8f240b2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "rating": "5",
      "name": "Leilani Rose",
      "text": "Avignon is such a beautiful property. The staff is amazing! Joana was so helpful! I will be coming back to hopefully rent!",
      "date": "2026-02-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_e748678eb253eebdbb7aa339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-7da6-75c5-b18a-40bb747632a0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-7da6-75c5-b18a-40bb747632a0",
        "storage_key": "property/6767906449167588/01a0101b-7da6-75c5-b18a-40bb747632a0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1 Petit",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=j1DsuSTz5p9"
    },
    {
      "id": "ec_b8327305a954594ab4d1e6cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "A2 Rhone - 1 bed, 1 bath, 794 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-7d9c-719c-89ee-0e295465265e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-7d9c-719c-89ee-0e295465265e",
        "storage_key": "property/6767906449167588/01a0101b-7d9c-719c-89ee-0e295465265e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2 Rhone",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8NSEPRU6ab3"
    },
    {
      "id": "ec_004dca6cbefbc37c43ac78aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-7cc9-754f-9915-359480eb5e9a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-7cc9-754f-9915-359480eb5e9a",
        "storage_key": "property/6767906449167588/01a0101b-7cc9-754f-9915-359480eb5e9a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A3 Carmes",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5okufU9Gd36"
    },
    {
      "id": "ec_901e36f3333f288003235c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "B1 Calvert - 2 bed, 2 bath, 1042 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-7c70-720c-8d04-2e17ad70f545.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-7c70-720c-8d04-2e17ad70f545",
        "storage_key": "property/6767906449167588/01a0101b-7c70-720c-8d04-2e17ad70f545.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "B1 Calvert",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NdvQ1UGdCDy"
    },
    {
      "id": "ec_46ab920eacf8b97bea73b22a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-7da5-735e-af50-b261e8f2d44f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-7da5-735e-af50-b261e8f2d44f",
        "storage_key": "property/6767906449167588/01a0101b-7da5-735e-af50-b261e8f2d44f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2 Cheval",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wzUF9TbXjf2"
    },
    {
      "id": "ec_234e12eca0c94336cc76eecf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "B3 Avignon - 2 bed, 2 bath, 1384 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-83f0-706e-8af9-31d34bb2c3d2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-83f0-706e-8af9-31d34bb2c3d2",
        "storage_key": "property/6767906449167588/01a0101b-83f0-706e-8af9-31d34bb2c3d2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B3 Avignon",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=xCPeKYCU7GQ"
    },
    {
      "id": "ec_5e4654aafef5b53fc55b9093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167588/01a0101b-83a1-727a-911e-956ceaaa1d99.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0101b-83a1-727a-911e-956ceaaa1d99",
        "storage_key": "property/6767906449167588/01a0101b-83a1-727a-911e-956ceaaa1d99.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "C1 Provence",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vcCtfU3hyWp"
    }
  ],
  "faqs": [
    {
      "id": "custom_e5d34f46-644d-46c6-ac75-5b992e78f2cf",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_6718fbb1-468d-46e5-aaf3-25d841f9f95f",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b24cde85-b9f3-495e-88c5-96d097e85190",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_f72c771b-4e1e-4d99-9de4-0b831d5190ef",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_b1ddfaa0-0874-426a-be70-b2243950be6d",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_c6022ef1-cc23-46e8-9b61-888eebb21838",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_b300c612-fbac-4285-a083-1eadf81e8015",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_38c8f810-6ccc-4154-b866-fb407f841eb0",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, sewer, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_49f89051-0729-4d9a-bea0-475b24f35edb",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_209421d3-41a1-4a16-97ce-207bac8fcf9f",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_d84e86e2-0ccd-4db9-afeb-31eea21c0149",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_f7d50393-b3d7-447f-ad5d-239d413f7803",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c91747de-c2f0-4dd2-9297-ed4096aede49",
      "question": "Do you offer covered parking?",
      "answer": "No, however, some of our floorplans offer attached garages. Please <a href=\"/contact-us\">contact our leasing office</a> for questions.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_f1732cfd-5f97-4313-b040-bc33623e8819",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_bfe1f4a5-7ced-4243-beda-fec7145fbedd",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_3bef6c9b-e5e4-4a21-8be6-6f0ee090d0f6",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-2b02-71d8-8d81-1d9c81c9a0c1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Avignon Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588"
    },
    {
      "lead_collector_id": "01a0c9ac-2bf7-7067-9411-7dd0a1300407",
      "lead_source": "LANDING_PAGE",
      "name": "Avignon Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-olathe-ks",
      "search_query": "in unit laundry apartments Olathe KS",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Olathe, KS",
      "h2_subtitle": "Discover the convenience of in-unit laundry apartments in Olathe, KS. Enjoy stylish living at Avignon Apartment Homes with modern amenities.",
      "page_copy": "Living in Avignon Apartment Homes means enjoying the luxury of in-unit laundry apartments in Olathe, KS. Our community offers well-designed one-, two-, and three-bedroom floor plans, each featuring modern amenities like private patios or balconies and upgraded appliances. Nestled in the charming city of Olathe, these European-inspired apartments provide seamless living experiences with effortless comfort.\n\nBeyond the convenience of in-home laundry, Avignon Apartment Homes boasts a range of community amenities designed to enrich your lifestyle. Engage in our planned social activities, or unwind with massage therapy. With an on-site conference room and efficient package services, every aspect of your life here is streamlined. Choose Avignon for a blend of style, comfort, and modern living, all with the ease of in-unit laundry facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Olathe, KS",
      "seo_description": "Experience in-unit laundry convenience at Avignon Apartment Homes in Olathe, KS. Stylish and spacious living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "luxury-pool-apartments-johnson-county",
      "search_query": "luxury pool apartments Johnson County",
      "category": "Amenity",
      "h1_title": "Luxury Pool Apartments in Johnson County",
      "h2_subtitle": "Explore luxury pool apartments in Johnson County's Avignon. Experience exceptional living with premium amenities in Olathe, KS.",
      "page_copy": "Avignon Apartment Homes offers a selection of luxury pool apartments in Johnson County, where residents can enjoy a blend of style and comfort. Our spacious one-, two-, and three-bedroom floor plans feature upgraded appliances, in-home laundry, and private outdoor spaces. Nestled in the heart of Olathe, KS, our community is designed with European-inspired touches that elevate everyday living.\n\nThe luxury pool at Avignon Apartment Homes is perfect for leisure and relaxation, complementing a suite of exceptional amenities like planned social activities, a conference room, and massage therapy services. This makes our community not just a place to live, but a lifestyle choice. Choose Avignon Apartment Homes for a premium living experience in Johnson County where luxury and convenience converge, offering the perfect setting for a balanced life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Pool Apartments Johnson County",
      "seo_description": "Discover luxury pool apartments at Avignon in Johnson County. Enjoy premium amenities in the heart of Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-avignon-neighborhood",
      "search_query": "air conditioned apartments in Avignon neighborhood",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in Avignon Neighborhood",
      "h2_subtitle": "Find comfort in air-conditioned apartments in the Avignon neighborhood. Avignon Apartment Homes offers ideal living conditions in Olathe, KS.",
      "page_copy": "Experience the ultimate comfort in air-conditioned apartments located in the beautiful Avignon neighborhood. Avignon Apartment Homes provides spacious one-, two-, and three-bedroom floor plans, all featuring essential amenities like in-home laundry and private patios or balconies. Positioned in the charming area of Olathe, KS, our European-inspired community ensures a serene, pleasant living environment.\n\nOur air-conditioned apartments offer a reprieve from the Kansas heat, making Avignon Apartment Homes a desirable place to call home. Beyond temperature control, enjoy community features that include a sparkling pool, planned social activities, and massage therapy. Whether you're relaxing in your climate-controlled apartment or making use of the on-site conference room, Avignon caters to your lifestyle needs with ease and style. Discover what it means to live in the well-appointed Avignon neighborhood today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments Avignon Neighborhood",
      "seo_description": "Stay cool in air-conditioned apartments at Avignon Apartment Homes in Olathe, KS. Enjoy comfort and community features.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "modern-apartments-dishwashers-66062",
      "search_query": "modern apartments with dishwashers in 66062",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Dishwashers in 66062",
      "h2_subtitle": "Discover the benefit of modern apartments with dishwashers in the 66062 area. Avignon Apartment Homes offers stylish living in Olathe, KS.",
      "page_copy": "Avignon Apartment Homes provides modern apartments with dishwashers in the heart of the 66062 area. Our one-, two-, and three-bedroom floor plans are designed with contemporary finishes and essential conveniences, including dishwashers and in-home laundry. Situated in Olathe, KS, our community reflects European-inspired elegance, catering to those who appreciate both style and functionality.\n\nIn addition to these in-home features, residents can enjoy a suite of community amenities such as a luxury pool, social activities, and a relaxing massage therapy center. Avignon Apartment Homes seamlessly combines the benefits of modern living with a charming neighborhood setting. Whether enjoying time in your fully-equipped kitchen or participating in community events, our apartments offer a vibrant lifestyle in the 66062 zip code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Dishwashers 66062",
      "seo_description": "Enjoy modern living with dishwashers at Avignon Apartment Homes in 66062. Premium amenities in Olathe, KS for an effortless lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-olathe-ks",
      "search_query": "fitness center apartments near Olathe KS",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near Olathe, KS",
      "h2_subtitle": "Discover apartments with a fitness center near Olathe, KS. Avignon Apartment Homes offers style and convenience in a vibrant community.",
      "page_copy": "At Avignon Apartment Homes, we offer fitness center apartments near Olathe, KS, where convenience meets modern living. Residents can choose from one-, two-, and three-bedroom floor plans that are both spacious and well-equipped. Positioned in the charming city of Olathe, our community effortlessly combines European-inspired elegance with everyday practicality.\n\nBeyond in-home amenities like upgraded appliances and private balconies, our community provides access to a premium fitness center. This is coupled with other features such as a luxury pool, massage therapy, and planned social activities, making Avignon a perfect choice for those seeking an active and comfortable lifestyle. Enjoy living in a community that prioritizes wellness and relaxation, right in the heart of Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near Olathe, KS",
      "seo_description": "Live near Olathe, KS in apartments with a fitness center at Avignon. Enjoy style, comfort, and amenities for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-olathe-ks",
      "search_query": "1 bedroom apartments olathe ks",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Olathe, KS",
      "h2_subtitle": "Explore 1 bedroom apartments in Olathe, KS at Avignon Apartment Homes. Enjoy spacious living with modern amenities.",
      "page_copy": "Avignon Apartment Homes offers exceptional 1 bedroom apartments in Olathe, KS, designed to suit a variety of lifestyles. Each of our one-bedroom floor plans is spacious, featuring in-home laundry, private patios or balconies, and high-quality finishes. Nestled in the heart of Olathe, our community exudes a European-inspired charm paired with convenient living spaces.\n\nExperience community living with access to premium amenities such as a welcoming pool, planned social events, and a tranquil massage therapy center. Whether relaxing in your stylish one-bedroom apartment or mingling in our community spaces, Avignon Apartment Homes in Olathe, KS, offers a comfortable and engaging environment perfectly suited for individuals and couples alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Olathe, KS",
      "seo_description": "Discover spacious 1 bedroom apartments in Olathe, KS at Avignon. Modern amenities and comfortable living await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-johnson-county",
      "search_query": "2 bedroom apartments johnson county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Johnson County",
      "h2_subtitle": "Find the perfect 2 bedroom apartment in Johnson County at Avignon Apartment Homes. Enjoy elegant living with premium amenities.",
      "page_copy": "Avignon Apartment Homes invites you to explore our stylish 2 bedroom apartments in Johnson County. Nestled in the beautiful community of Olathe, KS, each apartment offers modern conveniences such as in-home laundry and upgraded finishes. Our thoughtfully designed floor plans are spacious, providing a comfortable living experience tailored to fit your lifestyle.\n\nAs part of a vibrant community, residents benefit from amenities that enhance day-to-day living. From our sparkling pool to the conference room and package service, Avignon caters to your needs. With easy access to local attractions and services, our location in Johnson County ensures a blend of tranquility and urban convenience, perfect for families and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Johnson County",
      "seo_description": "Explore elegant 2 bedroom apartments in Johnson County at Avignon. Enjoy premium amenities and a convenient Olathe location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-avignon",
      "search_query": "3 bedroom apartments near avignon",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near Avignon",
      "h2_subtitle": "Discover spacious 3 bedroom apartments near Avignon at Avignon Apartment Homes. Experience luxurious living in Olathe, KS.",
      "page_copy": "At Avignon Apartment Homes, our 3 bedroom apartments near Avignon provide the perfect balance of luxury and comfort. Each apartment is designed with spacious interiors, featuring private patios or balconies and modern finishes, all set against a European-inspired backdrop. Situated in Olathe, KS, our community offers a unique lifestyle that's both sophisticated and convenient.\n\nBeyond the elegance of your home, Avignon offers a range of top-tier amenities. Enjoy access to planned social activities, a tranquil massage therapy room, and a well-equipped community center. Our location in the charming neighborhood of Avignon ensures that you're never far from local attractions and necessary conveniences, making it an ideal choice for those seeking a refined and community-driven living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near Avignon",
      "seo_description": "Explore luxurious 3 bedroom apartments near Avignon at Avignon Apartments in Olathe, KS. Enjoy spacious living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-near-walnut-grove-elementary-school",
      "search_query": "apartments near walnut grove elementary school olathe",
      "category": "School",
      "h1_title": "Apartments Near Walnut Grove Elementary School",
      "h2_subtitle": "Discover convenient apartments near Walnut Grove Elementary School. Avignon Apartment Homes combines location and lifestyle in Olathe.",
      "page_copy": "Located just a short distance from Walnut Grove Elementary School, Avignon Apartment Homes offers families and professionals easy access to quality education in Olathe. Our apartments are thoughtfully designed to provide a welcoming and enriching environment, featuring amenities such as in-home laundry, private balconies or patios, and polished finishes that balance comfort with style.\n\nBeyond the confines of each apartment, residents can enjoy a suite of community amenities that cater to diverse needs. Families will appreciate the planned social activities and the convenience of a reliable package service, while individuals might enjoy unwinding in our massage therapy center or using the well-equipped conference room. Situated near educational and recreational opportunities, our location in Olathe offers a superb living experience for all ages.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Walnut Grove Elementary School",
      "seo_description": "Find modern apartments near Walnut Grove Elementary School at Avignon in Olathe, combining location with lifestyle and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "avignon-apartments-near-regency-place-elementary",
      "search_query": "avignon apartments close to regency place elementary",
      "category": "School",
      "h1_title": "Avignon Apartments Near Regency Place Elementary",
      "h2_subtitle": "Live conveniently at Avignon Apartments, close to Regency Place Elementary. Enjoy a great location in Olathe with elegant amenities.",
      "page_copy": "Avignon Apartment Homes offers an ideal living environment for families seeking proximity to Regency Place Elementary. Located in the heart of Olathe, our apartments offer the charm of European-inspired architecture along with family-friendly conveniences. Each apartment features private outdoor spaces and modern in-home amenities, creating a perfect sanctuary for residents.\n\nOur vibrant community boasts a selection of amenities designed to enrich your daily life. Residents can partake in planned social activities, benefit from a professional conference room, and relax with available massage therapy. With easy access to educational institutions like Regency Place Elementary, Avignon Apartments provide a harmonious blend of location, community, and lifestyle that is perfect for all family dynamics.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Avignon Apartments Near Regency Place Elementary",
      "seo_description": "Experience family-friendly living at Avignon Apartments near Regency Place Elementary. Enjoy a prime Olathe location with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "spacious-apartments-by-heatherstone-elementary-66062",
      "search_query": "spacious apartments by heatherstone elementary 66062",
      "category": "School",
      "h1_title": "Spacious Apartments by Heatherstone Elementary",
      "h2_subtitle": "Explore spacious apartments by Heatherstone Elementary in the 66062 area. Avignon Apartment Homes offers comfort and convenience in Olathe.",
      "page_copy": "Avignon Apartment Homes invites you to experience spacious living with our apartments located conveniently close to Heatherstone Elementary in the 66062 ZIP code. Each unit is meticulously designed with modern upgrades, in-home laundry, and personal outdoor spaces, making it an excellent choice for those who appreciate both style and function.\n\nOur community is built around enhancing your lifestyle. Enjoy the benefits of planned social activities, unwind in our massage therapy room, or conduct business in our fully-equipped conference room. Nestled in Johnson County, living here means you’ll have access to top-notch educational facilities like Heatherstone Elementary, along with the comfort and luxury that Avignon Apartment Homes is known for, making it a standout option for families and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments by Heatherstone Elementary",
      "seo_description": "Discover spacious apartments by Heatherstone Elementary in Olathe, 66062. Avignon offers luxury living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "olathe-apartments-near-pioneer-trail-middle-school",
      "search_query": "olathe apartments near pioneer trail middle school",
      "category": "School",
      "h1_title": "Olathe Apartments Near Pioneer Trail Middle School",
      "h2_subtitle": "Find quality living at Olathe apartments near Pioneer Trail Middle School. Avignon Apartment Homes offers a vibrant community close by.",
      "page_copy": "Avignon Apartment Homes provides an exceptional living experience for those seeking Olathe apartments near Pioneer Trail Middle School. Nestled in a prime location, our community features beautifully designed one-, two-, and three-bedroom floor plans complete with modern amenities like in-home laundry, and private patios or balconies where residents can unwind.\n\nBeyond the individual units, Avignon offers a host of amenities designed to complement and elevate your lifestyle. Engage with neighbors through organized social activities, utilize our professionally equipped conference room, or relax with massage therapy services. Being close to Pioneer Trail Middle School means that families can enjoy the convenience of a reputable educational institution, while residing in a serene and supportive community in the heart of Olathe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe Apartments Near Pioneer Trail Middle School",
      "seo_description": "Live in Olathe near Pioneer Trail Middle School at Avignon. Enjoy top amenities and a prime location ideal for families and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "avignon-apartments-close-to-olathe-east-high-school",
      "search_query": "avignon apartments close to olathe east high school",
      "category": "School",
      "h1_title": "Avignon Apartments Close to Olathe East High School",
      "h2_subtitle": "Discover Avignon Apartments, conveniently close to Olathe East High School. Enjoy a remarkable living experience in Olathe, KS.",
      "page_copy": "Positioned in a sought-after area, Avignon Apartment Homes offers luxurious living close to Olathe East High School. Our community provides an array of spacious floor plans, each featuring contemporary finishes, in-home laundry, and private outdoor spaces, ideal for relaxation and comfort.\n\nResidents at Avignon can enjoy a wealth of amenities designed to enhance everyday living, such as planned social events, a state-of-the-art conference room, and rejuvenating massage therapy sessions. Living close to Olathe East High School allows families and students the convenience of quick commutes, coupled with the opportunity to be part of a vibrant community in Olathe. Experience the blend of superior living accommodations and a prime educational setting at Avignon Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Avignon Apartments Near Olathe East High School",
      "seo_description": "Find Avignon Apartments close to Olathe East High School. Enjoy a vibrant community and luxury amenities in a great Olathe location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-near-midamerica-nazarene-university-olathe",
      "search_query": "apartments near midamerica nazarene university olathe",
      "category": "School",
      "h1_title": "Apartments Near MidAmerica Nazarene University",
      "h2_subtitle": "Explore quality living in apartments near MidAmerica Nazarene University in Olathe. Avignon Apartment Homes offers the perfect blend of comfort and convenience.",
      "page_copy": "Avignon Apartment Homes welcome you to a community where comfort meets convenience, ideally located near MidAmerica Nazarene University in Olathe. Our apartments feature spacious one-, two-, and three-bedroom layouts, complete with modern finishes, private balconies or patios, and in-home laundry, ensuring a lifestyle of ease and sophistication.\n\nBeyond our thoughtfully designed living spaces, residents can enjoy an array of community amenities, including enriching social activities, a professional conference room, and relaxing massage therapy services. With MidAmerica Nazarene University just moments away, our location is superb for students and faculty alike, who seek a high-quality living environment with quick access to academic facilities. Live at Avignon Apartment Homes, where education and exceptional living go hand in hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MidAmerica Nazarene University",
      "seo_description": "Live near MidAmerica Nazarene University at Avignon in Olathe. Offering luxury apartments and amenities close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "avignon-living-near-prince-of-peace-catholic-school",
      "search_query": "avignon living near prince of peace catholic school",
      "category": "School",
      "h1_title": "Avignon Living Near Prince of Peace Catholic School",
      "h2_subtitle": "Experience the best of Avignon living near Prince of Peace Catholic School in Olathe. Our community offers convenience and comfort for families.",
      "page_copy": "Welcome to Avignon Apartment Homes, where superb Avignon living is paired with close proximity to Prince of Peace Catholic School. Our desirable location in Olathe not only provides convenient access to quality education but also offers beautifully crafted apartment homes complete with polished finishes, in-home laundry, and private outdoor spaces.\n\nOur residents enjoy a wealth of amenities beyond their front door, including engaging planned social activities, a fully equipped conference room, and calming massage therapy sessions. This makes Avignon an ideal choice for families seeking a supportive and enriching community close to Prince of Peace Catholic School. Discover the perfect harmony of location and lifestyle at Avignon Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Avignon Living Near Prince of Peace Catholic School",
      "seo_description": "Discover Avignon living near Prince of Peace Catholic School. Enjoy modern amenities and a prime Olathe location ideal for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-close-to-christ-lutheran-school-and-early-education",
      "search_query": "apartments close to christ lutheran school and early education",
      "category": "School",
      "h1_title": "Apartments Close to Christ Lutheran School",
      "h2_subtitle": "Find your ideal home in apartments close to Christ Lutheran School and Early Education Center. Avignon Apartment Homes offers comfort and convenience in Olathe.",
      "page_copy": "Avignon Apartment Homes provides an exceptional living experience close to Christ Lutheran School and Early Education Center. Located in the vibrant community of Olathe, our apartments feature spacious floor plans with modern finishes, in-home laundry facilities, and private patios or balconies to enhance your lifestyle.\n\nResidents cherish the community amenities, including planned social events, a professional conference room, and available massage therapy sessions—all designed to make life more enjoyable. Being close to Christ Lutheran School and Early Education Center offers families and educators unmatched convenience, allowing them to integrate seamlessly into the local educational community while enjoying the benefits of Avignon's luxurious living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Christ Lutheran School, Olathe",
      "seo_description": "Live near Christ Lutheran School at Avignon Apartments in Olathe. Enjoy upscale living with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "johnson-county-community-college-nearby-apartments",
      "search_query": "johnson county community college nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Johnson County Community College",
      "h2_subtitle": "Discover convenient living in apartments near Johnson County Community College. Avignon offers spacious and well-appointed homes perfect for students and staff.",
      "page_copy": "Avignon Apartment Homes present an ideal living solution for those seeking apartments close to Johnson County Community College. Located in Olathe, our community offers easy access to the college, perfect for students and faculty who prioritize both convenience and quality living.\n\nOur spacious units feature one-, two-, and three-bedroom floor plans, complemented by upscale in-home amenities like private patios, upgraded appliances, and efficient laundry facilities. Residents also enjoy our luxurious community offerings such as planned social activities, available massage therapy, and a business-friendly conference room. Experience the blend of convenience and comfort at Avignon Apartment Homes, a perfect fit for anyone affiliated with Johnson County Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Live at Avignon Apartments, near Johnson County Community College. Enjoy proximity and modern amenities in an ideal Olathe location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "edwards-campus-university-of-kansas-apartments-olathe",
      "search_query": "edwards campus university of kansas apartments olathe",
      "category": "School",
      "h1_title": "Apartments Near Edwards Campus, University of Kansas",
      "h2_subtitle": "Find modern living at our Olathe apartments near Edwards Campus, University of Kansas. Avignon offers convenience and comfort for students and faculty.",
      "page_copy": "Avignon Apartment Homes, located in Olathe, offers the perfect living solution for those looking to be near the Edwards Campus, University of Kansas. Our strategic location allows students and faculty easy access to campus, making daily commutes quick and stress-free. \n\nOur spacious one-, two-, and three-bedroom floor plans come with top-notch amenities like in-home laundry, private patios or balconies, and contemporary interiors. Enjoy community features such as social activities, a dedicated conference room, and massage therapy services, all designed to enhance your lifestyle. Experience the perfect balance of academic proximity and luxurious living at Avignon Apartment Homes as you focus on your educational journey at the University of Kansas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Edwards Campus KU Apartments in Olathe",
      "seo_description": "Live near Edwards Campus, University of Kansas in Olathe at Avignon Apartments. Enjoy upscale living, ideal for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-near-santa-marta-park-olathe",
      "search_query": "apartments near Santa Marta Park Olathe",
      "category": "Park",
      "h1_title": "Apartments Near Santa Marta Park, Olathe",
      "h2_subtitle": "Enjoy living in close proximity to Santa Marta Park with our Olathe apartments. Avignon offers tranquility and modern comfort in Johnson County.",
      "page_copy": "Avignon Apartment Homes provides the perfect blend of nature and comfort with its close proximity to Santa Marta Park in Olathe. Our community offers easy access to outdoor recreation and scenic surroundings, ideal for nature lovers and families alike.\n\nChoose from our spacious one-, two-, or three-bedroom apartments with upscale amenities such as private patios or balconies, upgraded appliances, and in-home laundry facilities. At Avignon, residents can indulge in a range of community features including planned social events, a relaxing conference room, and soothing massage therapy services. Relish the serenity and convenience of park-side living at Avignon Apartment Homes, a peaceful haven near Santa Marta Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Santa Marta Park, Olathe",
      "seo_description": "Live close to Santa Marta Park at Avignon Apartments in Olathe. Experience nature and modern amenities in one community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-close-to-eastbrooke-park-ks",
      "search_query": "apartments close to Eastbrooke Park KS",
      "category": "Park",
      "h1_title": "Apartments Close to Eastbrooke Park, KS",
      "h2_subtitle": "Discover the ideal blend of nature and comfort with our apartments near Eastbrooke Park. Enjoy peaceful living in the heart of Olathe, KS.",
      "page_copy": "Avignon Apartment Homes provides an unparalleled living experience with its proximity to Eastbrooke Park in Olathe, KS. Our community is perfect for those who enjoy a balance of nature with the convenience of city life, offering easy access to the park's green spaces and recreational offerings.\n\nSelect from expansive one-, two-, and three-bedroom apartments featuring upscale in-home amenities like private balconies, upgraded appliances, and in-home laundry. Enjoy our community perks including planned social activities, a well-equipped conference room, and relaxing massage therapy services. Experience the tranquility and accessibility of nearby Eastbrooke Park while living in luxury at Avignon Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Eastbrooke Park, Olathe KS",
      "seo_description": "Find your home at Avignon Apartments near Eastbrooke Park, KS. Enjoy modern amenities and a serene location in Olathe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "johnson-county-apartments-by-quailwood-park",
      "search_query": "Johnson County apartments by Quailwood Park",
      "category": "Park",
      "h1_title": "Johnson County Apartments by Quailwood Park",
      "h2_subtitle": "Experience premium living near Quailwood Park, in Johnson County with our spacious apartments. Enjoy comfort and style at Avignon.",
      "page_copy": "Avignon Apartment Homes offers an exceptional living experience in Johnson County, conveniently located by Quailwood Park. This location provides the perfect setting for those who enjoy the tranquility and recreational opportunities of nearby green spaces.\n\nOur one-, two-, and three-bedroom units are designed with comfort in mind, featuring private patios or balconies, contemporary finishes, and convenient in-home laundry facilities. Community amenities such as planned social events, a conference room, and massage therapy enhance your lifestyle. Embrace the perfect balance of serene park access and luxurious living at Avignon Apartment Homes, situated near Quailwood Park in the heart of Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Apartments by Quailwood Park",
      "seo_description": "Live near Quailwood Park in Johnson County at Avignon Apartments. Enjoy luxurious living amidst natural beauty and convenience in Olathe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-near-lake-olathe-park",
      "search_query": "apartments near Lake Olathe Park",
      "category": "Park",
      "h1_title": "Apartments Near Lake Olathe Park",
      "h2_subtitle": "Discover Avignon's premier apartments near Lake Olathe Park. Enjoy lush landscapes and luxurious amenities in Olathe, KS.",
      "page_copy": "Avignon Apartment Homes presents an exceptional lifestyle with our location near the scenic Lake Olathe Park. Perfect for outdoor enthusiasts, our community provides easy access to the park's trails and waterfront activities, ideal for relaxation and adventure.\n\nChoose from our spacious one-, two-, and three-bedroom floor plans, featuring stylish interiors with private patios or balconies, and convenient in-home laundry. Our residents enjoy a range of amenities, including upgraded appliances, planned social activities, and a soothing massage therapy service. Embrace the perfect mix of leisure and luxury at Avignon, just moments from the natural beauty of Lake Olathe Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Olathe Park, KS",
      "seo_description": "Live by Lake Olathe Park at Avignon Apartments. Enjoy a premium lifestyle with scenic views and modern conveniences in Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-close-to-cedar-niles-park-clare-road-trailhead",
      "search_query": "apartments close to Cedar Niles Park Clare Road Trailhead",
      "category": "Park",
      "h1_title": "Apartments Close to Cedar Niles Park Trailhead",
      "h2_subtitle": "Enjoy a vibrant lifestyle with our apartments near Cedar Niles Park Clare Road Trailhead. Discover modern comforts in a serene location.",
      "page_copy": "Avignon Apartment Homes is your gateway to serene living, situated conveniently close to the Cedar Niles Park Clare Road Trailhead. This location is perfect for nature lovers and those who appreciate easy access to scenic trails and outdoor activities.\n\nOur community offers thoughtfully designed one-, two-, and three-bedroom apartments, featuring private patios or balconies, polished interiors, and in-home laundry. Residents enjoy an array of amenities, including planned social activities, upgraded appliances, and a conference room ideal for both work and relaxation. Live in style and comfort at Avignon, and savor the proximity to the picturesque landscapes of Cedar Niles Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Cedar Niles Park Clare Road Trailhead",
      "seo_description": "Discover Avignon Apartments near Cedar Niles Park's Clare Road Trailhead. Enjoy modern living with access to beautiful trails in Olathe, KS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "olathe-ks-apartments-near-cedar-lake",
      "search_query": "Olathe KS apartments near Cedar Lake",
      "category": "Park",
      "h1_title": "Olathe KS Apartments Near Cedar Lake",
      "h2_subtitle": "Find your ideal home at Avignon, located near Cedar Lake in Olathe, KS. Our community combines comfort and nature.",
      "page_copy": "Discover the perfect blend of nature and luxury at Avignon Apartment Homes, situated in Olathe, KS, close to the beautiful Cedar Lake. With easy access to serene landscapes and recreational activities, our community is ideal for those looking to enjoy the best of outdoor living.\n\nChoose from our spacious one-, two-, and three-bedroom apartments, which feature private patios or balconies, in-home laundry facilities, and elegant finishes. Residents can also take advantage of a variety of amenities, including planned social activities, package service, and massage therapy. Enjoy the tranquility of Cedar Lake alongside Avignon's modern comforts in Olathe, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Olathe KS Apartments Near Cedar Lake",
      "seo_description": "Avignon Apartments offers modern living near Cedar Lake in Olathe, KS. Explore spacious floor plans with premium amenities near natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-near-black-bob-park-olathe",
      "search_query": "apartments near Black Bob Park Olathe",
      "category": "Park",
      "h1_title": "Apartments Near Black Bob Park, Olathe",
      "h2_subtitle": "Experience life at Avignon, close to Black Bob Park in Olathe. Revel in the convenience and comfort of our spacious homes.",
      "page_copy": "Situated near the lively Black Bob Park in Olathe, Avignon Apartment Homes offers an ideal location for those who love both recreation and relaxation. Benefit from quick access to the park's sports facilities, trails, and community events right from our beautiful apartments.\n\nExplore our range of one-, two-, and three-bedroom residences, featuring private patios or balconies and in-home laundry for your convenience. Our community amenities include planned social activities, upgraded appliances, and a conference room designed for productivity. Choose Avignon for a dynamic lifestyle, blending leisure and modern living in Olathe, just moments from Black Bob Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Black Bob Park, Olathe KS",
      "seo_description": "Enjoy living at Avignon Apartments near Black Bob Park in Olathe, KS. Discover a perfect combination of outdoor activities and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-by-prairie-center-park-olathe",
      "search_query": "apartments by Prairie Center Park Olathe",
      "category": "Park",
      "h1_title": "Apartments by Prairie Center Park, Olathe",
      "h2_subtitle": "Discover Avignon, located by Prairie Center Park in Olathe. Experience modern living with nature just steps away.",
      "page_copy": "Avignon Apartment Homes positions you perfectly by Prairie Center Park in Olathe, offering a lifestyle that merges comfort and outdoor adventure. Our apartments provide easy access to the park’s natural beauty and recreational amenities, making it an ideal location for those who cherish nature.\n\nOur spacious one-, two-, and three-bedroom apartments come equipped with in-home laundry, private patios or balconies, and sophisticated finishes. Enjoy amenities such as planned social activities, upgraded appliances, and a massage therapy room—all designed to elevate your living experience. Choose Avignon for a harmonious balance of community, nature, and modern comforts near Prairie Center Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Prairie Center Park, Olathe KS",
      "seo_description": "Live at Avignon Apartments near Prairie Center Park, Olathe. Embrace modern comfort with nature and park access at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167588",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Discover Avignon, conveniently located near Kansas City International Airport. Enjoy travel ease and luxurious living.",
      "page_copy": "Avignon Apartment Homes provides a strategic location for frequent travelers, being within convenient distance from Kansas City International Airport. If you seek the ideal balance between comfort and accessibility, our community is the perfect choice.\n\nEach of our one-, two-, and three-bedroom homes offers private patios or balconies, in-home laundry, and stylish interiors. Enjoy a suite of amenities designed for a tranquil living experience, including planned social activities, package service, and a conference room. Embrace the ease of travel while relishing in the upscale lifestyle at Avignon, where comfort meets convenience near Kansas City International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
      "featured_image_media": {
        "alt_text": "Open concept living and dining area with a kitchen island, bar stools, and dining table.",
        "public_id": "01a01019-760f-703c-b1f5-8983581fba49",
        "storage_key": "property/6767906449167588/01a01019-760f-703c-b1f5-8983581fba49.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Find comfort at Avignon Apartments near Kansas City International Airport. Experience convenient travel and luxurious living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701832050"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KKTBWSP6"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/b224f3e0-d0ed-4ad2-a24b-51fe946638d8/app.js?nocache=1&gaTracking=G-WR5TK57GJ1&buttonbgcolor=b3a369&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-586-8115"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlF2ajRiNzdybHlFM0pDL01XUW56WWc9PSIsInZhbHVlIjoiTzZTSmU0aDR1L2RHWkpBVk8rajY3Zz09IiwibWFjIjoiN2U0YmMyZWNlMjVjMzg5N2NlZGFiN2UyZWYyOGQ0YjZhNDY0OGY1MDk5YWRmZjVjM2UyMmI3MDQxYjQ2ZDBiYSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701832050",
  "custom_google_gtm_id": "GTM-KKTBWSP6",
  "custom_rollout_phase": "Batch 2",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/b224f3e0-d0ed-4ad2-a24b-51fe946638d8/app.js?nocache=1&gaTracking=G-WR5TK57GJ1&buttonbgcolor=b3a369&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-586-8115",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlF2ajRiNzdybHlFM0pDL01XUW56WWc9PSIsInZhbHVlIjoiTzZTSmU0aDR1L2RHWkpBVk8rajY3Zz09IiwibWFjIjoiN2U0YmMyZWNlMjVjMzg5N2NlZGFiN2UyZWYyOGQ0YjZhNDY0OGY1MDk5YWRmZjVjM2UyMmI3MDQxYjQ2ZDBiYSJ9",
  "custom_audioeye_site_id": "d980dc42-11ed-4241-9439-8c7ff0559b8e",
  "custom_audioeye_site_hash": "326f9845316fa174f00d354fca50a390"
};

export const generatedAt = '2026-11-03T23:03:24.668Z';
